<template>
  <div>
    <v-dialog v-model="loading" persistent width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{i18n[language].wait}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12 md3>
      </v-flex>
      <v-flex xs12 md6 v-if="lead">
        <v-card>
          <v-card-text>
            <v-layout row wrap :class="`${language=='ar' ? 'arFont' : ''}`" >
              <v-flex xs12>
                <span style="font-size:22px;">{{i18n[language].greeting}}</span>
                <span style="font-size:22px;font-weight:bold;">{{lead.name}}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-layout row wrap :class="`${language=='ar' ? 'arFont' : ''}`" >
                  <v-flex xs12>
                    <div style="font-size:16px;">{{i18n[language].phone}}:</div>
                    <div style="font-size:12px;font-weight:bold;">{{lead.phone_number_1}}</div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout row wrap :class="`${language=='ar' ? 'arFont' : ''}`" >
                  <v-flex xs12>
                    <div style="font-size:16px;">{{i18n[language].address}}:</div>
                    <div style="font-size:12px;font-weight:bold;">{{lead.address}}</div>
                    <div style="font-size:12px;font-weight:bold;">{{lead.city}}</div>
                    <div style="font-size:12px;font-weight:bold;">{{lead.country}}</div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout v-if="products" row wrap pb-4 pt-2 px-3 my-2 mt-4
              :class="`${language=='ar' ? 'arFont' : ''} elevation-2`" 
              >
              <v-flex xs12 py-2 pb-3 style="font-size:16px;font-weight:bold;">
                {{ i18n[language].cart_title}}
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs2 class="text-xs-center" style="font-weight:bold;font-size:11px;">
                    {{i18n[language].img}}
                  </v-flex>
                  <v-flex xs8 px-2 class="text-xs-center" style="font-weight:bold;font-size:11px;">
                    {{i18n[language].product}}
                  </v-flex>
                  <v-flex xs2 class="text-xs-center" style="font-weight:bold;font-size:11px;">
                    {{i18n[language].quantity}}
                  </v-flex>
                </v-layout>
                <v-layout mb-1 row wrap v-for="(item, i) in lead.order" :key="i+'-item'" align-center>
                  <v-flex xs2 class="text-xs-center">
                    <img v-if="item.img" :src="item.img" width="100%">
                  </v-flex>
                  <v-flex xs8 px-2 class="text-xs-center">
                    {{ language=='ar' ? item.name_ar : item.name_en }}
                  </v-flex>
                  <v-flex xs2 class="text-xs-center">
                    {{ item.quantity }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap py-3 mb-4 :class="`${language=='ar' ? 'arFont' : ''} elevation-2 px-3`" style="background:#efefef;">
              <v-flex xs8>
                <span style="font-size:16px;">{{i18n[language].total_before}}</span>
              </v-flex>
              <v-flex xs4 class="text-xs-center">
                <span style="font-size:16px;" v-if="!lead.manual_total">{{lead.total_converted_after_tax}} {{lead.currency}}</span>
                <span style="font-size:16px;" v-if="lead.manual_total">{{lead.manual_total}} {{lead.currency}}</span>
              </v-flex>
              <v-flex xs8>
                <span style="font-size:22px;font-weight:bold;">{{i18n[language].total}}</span>
              </v-flex>
              <v-flex xs4 class="text-xs-center">
                <span style="font-size:22px;font-weight:bold;">{{lead.online_total}} {{lead.currency}}</span>
              </v-flex>
              <v-flex xs8>
                <span style="font-size:16px;font-weight:bold;color:#4CAF50;">{{i18n[language].save}}</span>
              </v-flex>
              <v-flex xs4 class="text-xs-center">
                <span style="font-size:16px;font-weight:bold;color:#4CAF50;" v-if="!lead.manual_total">{{(Math.round(parseFloat(lead.total_converted_after_tax) - parseFloat(lead.online_total))).toFixed(0)}} {{lead.currency}}</span>

                <span style="font-size:16px;font-weight:bold;color:#4CAF50;" v-if="lead.manual_total">{{(Math.round(parseFloat(lead.manual_total) - parseFloat(lead.online_total))).toFixed(0)}} {{lead.currency}}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap :class="`${language=='ar' ? 'arFontOnly' : ''}`" >
              <v-flex xs12 v-if="paid">
                <v-layout row wrap>
                  <v-flex xs12 class="container">
                    <svg id="successAnimation" class="animated" xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 70 70">
                      <circle id="successAnimationCircle" cx="35" cy="35" r="24" stroke="#005596" stroke-width="2" stroke-linecap="round" fill="transparent"/>
                      <polyline id="successAnimationCheck" stroke="#005596" stroke-width="2" points="23 34 34 43 47 27" fill="transparent"/>
                    </svg>
                  </v-flex>
                  <v-flex xs12 :class="`${language=='ar' ? 'arFont' : ''} text-xs-center`" style="font-size:24px;color:#005596;font-weight:bold;">
                    {{i18n[language].paid}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 px-5 py-2 class="text-xs-center" v-if="!paid">
                <img src="/payment.png" width="70%">
              </v-flex>
              <v-flex xs12 v-if="!paid">
                <form action="https://ashyaatpayment.web.app/d/" class="paymentWidgets" data-brands="VISA MASTER AMEX"></form>
              </v-flex>
            </v-layout>
          </v-card-text>  
        </v-card>
        
      </v-flex>
      <v-flex xs12 md3>
        
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate, sleep} from '@/customFunction';
import axios from 'axios';
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};

export default {
  data(){
    return {
      loading:false,
      lead:null,
      token:null,
      paid:false,
      cart_token:null,
      language:'en',
      products:false,
      i18n:{
        ar:{
          total:'المجموع عند الدفع الالكتروني',
          greeting:'اهلا بك ',
          cart_title:`المنتجات داخل الطلب`,
          phone:`هاتف`,
          address:`العنوان`,
          wait:`الرجاء الانتظار`,
          img:`صورة`,
          product:`اسم المنتج`,
          quantity:`الكمية`,
          total_before:`المجموع عند الدفع عند الاستلام`,
          save:`التوفير`,
          paid:`تم الدفع`
        },
        en:{
          total:'Total',
          greeting:'Welcome again ',
          cart_title:`Items in order`,
          phone:`Phone`,
          address:`Address`,
          wait:`Please Wait`,
          img:`Image`,
          product:`Product`,
          quantity:`Quantity`,
          total_before:`Total on COD`,
          save:`Saved`,
          paid:`This order was paid for successfully`

        }
      }
    }
  }, 
  methods:{
    async decrypt(text) {
      let data = {
        text:text
      }
      let a = await axios.post(`${apiBase}/ashhash`, data, headers).then(x=>x.data)
      console.log(a)
      return a.decrypted

    },
    async encrypt(text) {
      let data = {
        text:text,
        action:'encrypt'
      }
      let a = await axios.post(`${apiBase}/ashhash`, data, headers).then(x=>x.data)
      console.log(a)
      return a.encrypted

    },
    async GetLead(key){
      let a = await store.collection('leads').doc(key).get().then(x=>x.data())
      console.log(a)
      if(a){
        a.key = key
        this.lead = a
        this.language = a.language
        this.getProducts()
        let b = await db.ref(`settings/app/currency/${a.payment_cc}`).once('value').then(x=>x.val())
        if (a.paid) {
          this.paid = true
          this.loading = false
        } else {
          this.genCartId(a, parseFloat(b)*parseFloat(a.online_total), a.currency)
          await store.collection('leads').doc(a.key).update({
            payment_visit_timestamp:new Date().getTime(),
            payment_visit_date:getCDate(),
          })
        }
      }
    },
    replaceCity(o, country){
      let city =  [
          {"ar":"عمان","en":"Amman"},
          {"ar":"اربد","en":"Irbid"},
          {"ar":"الزرقاء","en":"Zarqa"},
          {"ar":"الرمثا","en":"Ramtha"},
          {"ar":"عجلون","en":"Ajloon"},
          {"ar":"جرش","en":"Jerash"},
          {"ar":"مادبا","en":"Madaba"},
          {"ar":"الازرق","en":"azraq"},
          {"ar":"غور الصافي","en":"Ghor alsafi"},
          {"ar":"الكرك","en":"Karak"},
          {"ar":"الطفيلة","en":"Tafileh"},
          {"ar":"معان","en":"Ma'an"},
          {"ar":"العقبة","en":"Aqapa"},
          {"ar":"البتراء","en":"petra"},
          {"ar":"المفرق","en":"Mafraq"},
          {"ar":"السلط","en":"Salt"},
          {"ar":"دبي","en":"Dubai"},
          {"ar":"ابو ظبي","en":"Abu Dhabi"},
          {"ar":"الشارقة","en":"Sharjah"},
          {"ar":"راس الخيمة","en":"Ras Al Khaimah"},
          {"ar":"العين","en":"AL Ain"},
          {"ar":"عجمان","en":"Ajman "},
          {"ar":"الفجيرة","en":"Fujairah"},
          {"ar":"ام القيوين","en":"Um Al Quiwan"},
          {"ar":"خورفكان","en":"Khawr Fakkan"},
          {"ar":"دبا الحصن","en":"Diba Al Hesn"},
          {"ar":"مكة","en":"Makkah"},
          {"ar":"المدينة","en":"Madinah"},
          {"ar":"الرياض","en":"Riyadh"},
          {"ar":"جدة","en":"Jeddah"},
          {"ar":"تبوك","en":"Tabuk"},
          {"ar":"الدمام","en":"Dammam"},
          {"ar":"الاحساء","en":"Al Hassa"},
          {"ar":"القطيف","en":"Qatif"},
          {"ar":"خميس مشيط","en":"Khamis Mushait"},
          {"ar":"المظيلف","en":"Muthaleif"},
          {"ar":"الهفوف","en":"Hofuf"},
          {"ar":"المبرز","en":"Mubaraz"},
          {"ar":"الطائف","en":"Taif"},
          {"ar":"نجران","en":"Najran"},
          {"ar":"حفر الباطن","en":"Hafer Al Batin"},
          {"ar":"الجبيل","en":"Jubail"},
          {"ar":"الخرج","en":"Kharj"},
          {"ar":"الثقبة","en":"Thuqba"},
          {"ar":"ينبع البحر","en":"Yanbu Al Baher"},
          {"ar":"الخبر","en":"Khobar"},
          {"ar":"عرعر","en":"Arar"},
          {"ar":"الحوية طائف","en":"Hawea/Taif"},
          {"ar":"العنيزة","en":"Onaiza"},
          {"ar":"سكاكا","en":"Sakaka"},
          {"ar":"جيزان","en":"Jazan"},
          {"ar":"القريات","en":"Qurayat"},
          {"ar":"الظهران","en":"Dhahran"},
          {"ar":"الباحة","en":"Baha"},
          {"ar":"الزلفي","en":"Zulfi"},
          {"ar":"الرس","en":"AlRass"},
          {"ar":"وادي الدواسر","en":"Wadi El Dwaser"},
          {"ar":"بيشة","en":"Bisha"},
          {"ar":"شروره","en":"Sharourah"},
          {"ar":"بحرة","en":"Bahara"},
          {"ar":"تاروت","en":"Tarut"},
          {"ar":"الدوادمي","en":"Dawadmi"},
          {"ar":"صبياء","en":"Sabya"},
          {"ar":"بيش","en":"Bish "},
          {"ar":"احد مسارحة","en":"Ahad Masarha "},
          {"ar":"احد رفيدة","en":"Ahad Rufaidah"},
          {"ar":"احد","en":"Ahad Masarha "},
          {"ar":"بارق","en":"Bareq"},
          {"ar":"الحوطة","en":"Hawtat Bani Tamim"},
          {"ar":"الافلاج","en":"Aflaj"},
          {"ar":"الكويت","en":"Kuwait City"},
          {"ar":"الجهراء","en":"Jahra"},
          {"ar":"حولي","en":"Hawalli"},
          {"ar":"الفروانية","en":"Farwaniyah"},
          {"ar":"مبارك","en":"Mubarak Al kabeer"},
          {"ar":"الاحمدي","en":"Ahmadi"},
          {"ar":"بيروت","en":"بيروت"},
          {"ar":"البقاع","en":"البقاع"},
          {"ar":"البترون","en":"البترون"},
          {"ar":"بشري","en":"بشري"},
          {"ar":"عكار","en":"عكار"},
          {"ar":"زغرتا","en":"زغرتا"},
          {"ar":"طرابلس","en":"طرابلس"},
          {"ar":"الضنية","en":"الضنية"},
          {"ar":"الكورة","en":"الكورة"},
          {"ar":"بعلبك","en":"بعلبك"},
          {"ar":"راشيا","en":"راشيا"},
          {"ar":"زحلة","en":"زحلة"},
          {"ar":"الهرمل","en":"الهرمل"},
          {"ar":"بعبدا","en":"بعبدا"},
          {"ar":"الشوف","en":"الشوف"},
          {"ar":"عاليه","en":"عاليه"},
          {"ar":"كسروان","en":"كسروان"},
          {"ar":"المتن","en":"المتن"},
          {"ar":"جزين","en":"جزين"},
          {"ar":"صيدا","en":"صيدا"},
          {"ar":"بنت جبيل","en":"بنت جبيل"},
          {"ar":"حاصبيا","en":"حاصبيا"},
          {"ar":"مرجعيون","en":"مرجعيون"},
          {"ar":"النبطية","en":"النبطية"},
          {"ar":"نزوى","en":"Nizwa"},
          {"ar":"صحار","en":"Sohar"},
          {"ar":"الرستاق","en":"rustaq"},
          {"ar":"هيما","en":"Haima"},
          {"ar":"صور","en":"Sur"},
          {"ar":"ابراء","en":"Ibra"},
          {"ar":"عبري","en":"Ibri"},
          {"ar":"مسقط","en":"Muscat"},
          {"ar":"صلالة","en":"Salalah"},
          {"ar":"البريمي","en":"BURAIMI"},
          {"ar":"الدوحة","en":"Doha"},
          {"ar":"الريان","en":"Alrayan"},
          {"ar":"الوكرة","en":"Al Wakrah"},
          {"ar":"خور","en":"Al Khor"},
          {"ar":"ام سعيد","en":"Umm Sa'Id"},
          {"ar":"مدينة الشمال","en":"مدينة الشمال"},
          {"ar":"الرويس","en":"Alrawais"},
          {"ar":"دخان","en":"Dukhan"},
          {"ar":"المنامة","en":"Manama"},
          {"ar":"المحرق","en":"Muharraq"},
          {"ar":"الرفاع","en":"RIFA"},
          {"ar":"حمد","en":"Hamad Town"},
          {"ar":"عالي","en":"Aali"},
          {"ar":"عيسى","en":"Isa Town"},
          {"ar":"سترة","en":"Sitra"},
          {"ar":"البديع","en":"BADEE"},
          {"ar":"جد حفص","en":"Jidhafs"},
          {"ar":"المالكية","en":"AL MALKIAH"},
          {"ar":"قرية سار","en":"Saar"},
          {"ar":"طريف","en":"Turaif"},
          {"ar":"ابها","en":"Abha"},
          {"ar":"حائل","en":"Hail"},
          {"ar":"القصيم","en":"Qassim"},
          {"ar":"السالمية","en":"Salmiya"},
          {"ar":"الباطنة","en":"Albatnah"},
          {"ar":"اسطنبول","en":"stanbul"},
          {"ar":"انقرا","en":"Ankara"},
          {"ar":"الحوية ظهران","en":"Haweyah dahran"},
          {"ar":"الشعيبة","en":"Shuaiba"},
          {"ar":"مباركية","en":"Mubarakiah"},
          {"ar":"أبو حليفة","en":"Abu Halifa"},
          {"ar":"تيماك","en":"Taymac"},
          {"ar":"الصليبية","en":"Sulaybiyah"},
          {"ar":"شرق","en":"Sharq"},
          {"ar":"الشويخ","en":"Shuwaikh"},
          {"ar":"صباح السالم","en":"Sabah Al-Salem"},
          {"ar":"الصباحية","en":"Sabahiyah"},
          {"ar":"الرميثة","en":"Rumaithia"},
          {"ar":"جبل الشيوخ","en":"Jalib Al-Shuyukh"},
          {"ar":"الرقة","en":"Riqqah"},
          {"ar":"بنيد القار","en":"Bneid Al-Qar"},
          {"ar":"كريم","en":"Karim"},
          {"ar":"رويدة","en":"Rwaydah"},
          {"ar":"المنقف","en":"Mangaf"},
          {"ar":"حريق","en":"Hareeq"},
          {"ar":"قيلية","en":"Gilea"},
          {"ar":"الفردوس","en":"Fardaws"},
          {"ar":"مجاردة","en":"Majarda"},
          {"ar":"العارضة","en":"Al Ardah"},
          {"ar":"سلوى","en":"Salwa"},
          {"ar":"بقيق","en":"Baqiq"},
          {"ar":"عين دار","en":"Ain Dar"},
          {"ar":"عنك","en":"Anak"},
          {"ar":"عوامية","en":"Awamiah"},
          {"ar":"حرض","en":"Harad"},
          {"ar":"جديد","en":"Jadidah Arar"},
          {"ar":"جفر","en":"Al Jafer"},
          {"ar":"الجش","en":"Al-Jsh"},
          {"ar":"خضرية","en":"Khodaria"},
          {"ar":"الخفجي","en":"Khafji"},
          {"ar":"جنوب خيطان","en":"South Khaitan"},
          {"ar":"منيفة","en":"Mnefah"},
          {"ar":"المهبولة","en":"Mahboula"},
          {"ar":"مليجة","en":"Molejah"},
          {"ar":"نابية","en":"Nabiya"},
          {"ar":"مشرف","en":"Mishref"},
          {"ar":"نانياه","en":"Nanyah"},
          {"ar":"نويرية","en":"Noweirieh"},
          {"ar":"عجام","en":"Ojam"},
          {"ar":"هدية","en":"Hadiya"},
          {"ar":"عثمانية","en":"Othmanyah"},
          {"ar":"بيان","en":"Bayan"},
          {"ar":"قارة","en":"Qarah"},
          {"ar":"راس تنورة","en":"Ras Tanura"},
          {"ar":"رحيمة","en":"Rahima"},
          {"ar":"الفنطاس","en":"Fintas"},
          {"ar":"صفوة","en":"Safwa"},
          {"ar":"سيهات","en":"Seihat"},
          {"ar":"صفانية","en":"Safanyah"},
          {"ar":"سنابس","en":"Snabs"},
          {"ar":"ابرق خيطان","en":"Abraq Khaitan"},
          {"ar":"الفحيحل","en":"Fahaheel"},
          {"ar":"تنجيب","en":"Tanjeeb"},
          {"ar":"العضيلية","en":"Udhaliyah"},
          {"ar":"السره","en":"Surra"},
          {"ar":"عيون","en":"Uyun"},
          {"ar":"جعارنة","en":"Ja'Araneh"},
          {"ar":"النزهة","en":"Nuzha"},
          {"ar":"اسفان","en":"Asfan"},
          {"ar":"وادي فاطمة","en":"Wadi Fatmah"},
          {"ar":"مستورة","en":"Mastura"},
          {"ar":"الجابرية","en":"Jabriya"},
          {"ar":"الجموم","en":"Jumum"},
          {"ar":"شعيبة","en":"Shoaiba"},
          {"ar":"الصفاة","en":"Safat"},
          {"ar":"العبدلي","en":"Abdali"},
          {"ar":"الهدا","en":"Alhada"},
          {"ar":"الضجيج","en":"Dajeej"},
          {"ar":"ذهبان","en":"Dhahban"},
          {"ar":"شرايعي","en":"Shraie'E"},
          {"ar":"بحرة الموجود","en":"Bahrat Al Moujoud"},
          {"ar":"الغرافة","en":"Gharafa"},
          {"ar":"نوارية","en":"Nwariah"},
          {"ar":"رابغ","en":"Rabigh"},
          {"ar":"شميسي","en":"Shumeisi"},
          {"ar":"توال","en":"Towal"},
          {"ar":"ثول","en":"THUWAL"},
          {"ar":"عمق","en":"Amaq"},
          {"ar":"الشحانية","en":"Shahaniya"},
          {"ar":"الشقيق","en":"Ash Shuqaiq"},
          {"ar":"برك","en":"Birk"},
          {"ar":"قحمة","en":"Qahmah"},
          {"ar":"رجال المعاع","en":"Rejal Alma'A"},
          {"ar":"السيلية","en":"Al Sailiya"},
          {"ar":"صامطة","en":"Samtah "},
          {"ar":"ابو عريش","en":"Abu Areish"},
          {"ar":"بلجرشي","en":"Biljurashi"},
          {"ar":"ظهران الجنوب","en":"Dhahran Al Janoob"},
          {"ar":"ضمد","en":"Damad"},
          {"ar":"درب","en":"Darb"},
          {"ar":"ضبا","en":"Duba"},
          {"ar":"هرجا","en":"Harjah"},
          {"ar":"كاربوس","en":"Karboos"},
          {"ar":"منداك","en":"Mandak"},
          {"ar":"مخوى","en":"Mikhwa"},
          {"ar":"محايل عسير","en":"Mohayel Aseer"},
          {"ar":"الخوير","en":"Al Khuwayr"},
          {"ar":"نماس","en":"Namas"},
          {"ar":"قنفذة","en":"Qunfudah"},
          {"ar":"سارة عبيدة","en":"Sarat Obeida"},
          {"ar":"واديين","en":"Wadeien"},
          {"ar":"المفجر","en":"Al Mafjar"},
          {"ar":"ينبع","en":"Yanbu"},
          {"ar":"فراسان","en":"Farasan"},
          {"ar":"حناكية","en":"Hinakeya"},
          {"ar":"الهتمي","en":"Al Hitmi"},
          {"ar":"خورما","en":"Khurma"},
          {"ar":"رانيا","en":"Rania"},
          {"ar":"تربة","en":"Turba"},
          {"ar":"سبت العلايا","en":"Sabt El Alaya"},
          {"ar":"بلاحمر","en":"Balahmar"},
          {"ar":"بلاسمر","en":"Balasmar"},
          {"ar":"الوجه","en":"Wajeh (Al Wajh)"},
          {"ar":"ام صلال علي","en":"Umm Salal 'Ali"},
          {"ar":"هالة عمار","en":"Halat Ammar"},
          {"ar":"حقيل","en":"Haqil"},
          {"ar":"تانومة","en":"Tanuma"},
          {"ar":"املج","en":"Umluj"},
          {"ar":"تثليث","en":"Tatleeth"},
          {"ar":"تيما","en":"Tayma"},
          {"ar":"التولة","en":"Atawleh"},
          {"ar":"دوس","en":"Daws"},
          {"ar":"الكعابية","en":"Al Qa`abiyah"},
          {"ar":"خيبر","en":"Khaibar"},
          {"ar":"ليث","en":"Laith"},
          {"ar":"راس لفان","en":"Ras Laffan"},
          {"ar":"عولا","en":"Oula"},
          {"ar":"خصاوية","en":"Khasawyah"},
          {"ar":"ثابية","en":"Thabya"},
          {"ar":"بدر","en":"Bader"},
          {"ar":"ظلم","en":"Dhalm"},
          {"ar":"المويا","en":"Al Moya"},
          {"ar":"كراع","en":"Kara'A"},
          {"ar":"ضرما","en":"Dhurma"},
          {"ar":"الدرعية","en":"Dere'Iyeh"},
          {"ar":"الدليمية","en":"Al Dalemya"},
          {"ar":"كويع","en":"Quwei'Ieh"},
          {"ar":"عقلة الصقر","en":"Uqlat Al Suqur"},
          {"ar":"الخليفات ","en":"Al Khalifat"},
          {"ar":"ارطاوية","en":"Artawiah"},
          {"ar":"جلاجل","en":"Jalajel"},
          {"ar":"ام باب","en":"Umm Bab"},
          {"ar":"ام الجماجم","en":"Um Aljamajim"},
          {"ar":"الغاط","en":"Alghat"},
          {"ar":"حوطة سدير","en":"Hotat Sudair"},
          {"ar":"ام صلال محمد","en":"Umm Salal Muhammad"},
          {"ar":"مارت","en":"Mrat"},
          {"ar":"قصب","en":"Qasab"},
          {"ar":"روضة سدير","en":"Rowdat Sodair"},
          {"ar":"الجميلية","en":"Al Jumaliyah"},
          {"ar":"عفيف","en":"Afif"},
          {"ar":"صياح","en":"Assiyah"},
          {"ar":"عين ابن فهيد","en":"Ayn Fuhayd"},
          {"ar":"الاضبة","en":"Al Adhbah"},
          {"ar":"قيصومة","en":"Qaysoomah"},
          {"ar":"طبرجل","en":"Tabrjal"},
          {"ar":"الجسرة","en":"Al Jasrah"},
          {"ar":"ماجما","en":"Majma"},
          {"ar":"شقرا","en":"Shaqra"},
          {"ar":"بداية","en":"Badaya"},
          {"ar":"البكيرية","en":"Bukeiriah"},
          {"ar":"ميدينهاب","en":"Midinhab"},
          {"ar":"مذنب","en":"Muzneb"},
          {"ar":"ساجر","en":"Sajir"},
          {"ar":"جوف","en":"Jouf"},
          {"ar":"بريدة","en":"Buraidah"},
          {"ar":"دومة الجندل","en":"Domat Al Jandal"},
          {"ar":"حديثة","en":"Hadeethah"},
          {"ar":"رفحاء","en":"Rafha"},
          {"ar":"خماسين","en":"Khamaseen"},
          {"ar":"كارة","en":"Kara"},
          {"ar":"رياض الخبراء","en":"Riyadh Al Khabra"},
          {"ar":"شفاعة","en":"Shefa'A"},
          {"ar":"سليل","en":"Sulaiyl"},
          {"ar":"بطحاء","en":"Batha"},
          {"ar":"قرية العليا","en":"Qariya Al olaya"},
          {"ar":"راس الخير","en":"Ras Al Kheir"},
          {"ar":"سلواء","en":"Salwa"},
          {"ar":"سرار","en":"Sarar"},
          {"ar":"ثمير","en":"Thumair"},
          {"ar":"البدع","en":"Al Bada"},
          {"ar":"عقيق","en":"Aqiq"},
          {"ar":"قيلوا","en":"Gilwa"},
          {"ar":"روي","en":"Ruwi"},
          {"ar":"خليص","en":"Khulais"},
          {"ar":"مهد الذهب","en":"Mahad Al dahab"},
          {"ar":"نمرة","en":"Nimra"},
          {"ar":"دعيلم","en":"Daelim"},
          {"ar":"سحنا","en":"Sahna"},
          {"ar":"درعاب","en":"Deraab"},
          {"ar":"حريمل","en":"Huraymala"},
          {"ar":"عياينة","en":"Oyaynah"},
          {"ar":"رماح","en":"Remah"},
          {"ar":"صلبوخ","en":"Salbookh"},
          {"ar":"غالا","en":"Ghala"},
          {"ar":"ثادق","en":"Thadek"},
          {"ar":"مزهمية","en":"Muzahmiah"},
          {"ar":"تبراك","en":"Tebrak"},
          {"ar":"المدى","en":"Al Mada"},
          {"ar":"سوبيكا","en":"Subheka"},
          {"ar":"تاندا","en":"Tanda"},
          {"ar":"الغبرة","en":"Ghubra"},
          {"ar":"تريب","en":"Turaib"},
          {"ar":"وادي بن هسبل","en":"Wadi Bin Hasbal"},
          {"ar":"الحمرية","en":"Hamriya"},
          {"ar":"مدينة قابوس","en":"Madinat Sultan Qaboos"},
          {"ar":"القرم","en":"Qurum"},
          {"ar":"الرسيل","en":"Rusayl"},
          {"ar":"السيب","en":"Seeb"},
          {"ar":"سداب","en":"Sidab"},
          {"ar":"وادي عدي","en":"Wadi Adai"},
          {"ar":"السليف","en":"As Sulaif"},
          {"ar":"طيوي","en":"Tiwi"},
          {"ar":"مطرح","en":"Muttrah"},
          {"ar":"مرمول","en":"Marmul"},
          {"ar":"فرق","en":"Firq"},
          {"ar":"ادم","en":"Adam"},
          {"ar":"فهود","en":"Fahud"},
          {"ar":"ظلكوت","en":"Dhalkut"},
          {"ar":"بدية","en":"Bisiyah"},
          {"ar":"العقير","en":"Al Aqir"},
          {"ar":"الدقم","en":"Al Duqm"},
          {"ar":"الاشخرة","en":"Al Ashkarah"},
          {"ar":"الحمراء","en":"Al Hamra"},
          {"ar":"وادي بني خلد","en":"Wadi Bani Khalid"},
          {"ar":"القابل ","en":"Al Kabil"},
          {"ar":"الكامل-الواف","en":"Al Kamil Wal Wafi"},
          {"ar":"تمريت","en":"Thamrait"},
          {"ar":"سناو","en":"Sinaw"},
          {"ar":"ولاية صحم","en":"Saham"},
          {"ar":"نخل","en":"Nakhl"},
          {"ar":"مصيرة","en":"Masirah"},
          {"ar":"ولاية منح","en":"Manah"},
          {"ar":"سنينة","en":"Sunaina"},
          {"ar":"ولاية محضة","en":"Mahdha"},
          {"ar":"ولاية مدحاء","en":"Madha"},
          {"ar":"بهلاء","en":"Bahla"},
          {"ar":"بركاء","en":"Barka"},
          {"ar":"ولاية بدبد","en":"Bidbid"},
          {"ar":"خصب","en":"Khasab"},
          {"ar":"جعلان بن علي","en":"Jaalan Bani Bu Ali"},
          {"ar":"ازكي","en":"Izki"},
          {"ar":"البدية","en":"Al Bidayah"},
          {"ar":"فنجا","en":"Fanja"},
          {"ar":"بخاء","en":"Bukha"},
          {"ar":"فلج القبائل","en":"Falaj Al Qabail"},
          {"ar":"دما والطائين","en":"Dima Wattayeen"},
          {"ar":"ولاية ضنك","en":"Dhank"},
          {"ar":"ازرق","en":"Azraq"},
          {"ar":"مباركية ","en":"Mubarakiah"},
          {"ar":"مبارك ","en":"Mubarak al kabeer "},
          {"ar":"الشرق","en":"Sharq"},
          {"ar":"صباحية","en":"Sabahiyah"},
          {"ar":"الرميثية","en":"Rumaithia"},
          {"ar":"جليب الشيوخ","en":"Jalib Al-Shuyukh"},
          {"ar":"سويحان","en":"Suwayhan"},
          {"ar":"سيلا","en":"Sila"},
          {"ar":"حبشان","en":"Habshan"},
          {"ar":"مدينة الكويت","en":"Kuwait City"},
          {"ar":"مفرق","en":"Mafraq"},
          {"ar":"المرفا","en":"Al Marfa"},
          {"ar":"الدوس","en":"Al Duss"},
          {"ar":"الدربانية","en":"Al Dharbaniyah"},
          {"ar":"العارضية","en":"Ardiyah"},
          {"ar":"الديد","en":"Al Dhayd"},
          {"ar":"عكامية","en":"Akamiyah"},
          {"ar":"الارضية","en":"Al Ardiyah"},
          {"ar":"عباديلا","en":"Abadilah"},
          {"ar":"ابو هايل","en":"Abu Hayl"},
          {"ar":"بطين","en":"Buteen"},
          {"ar":"المقتة","en":"Al Maqta"},
          {"ar":"مصفح","en":"Mussafah"},
          {"ar":"ام النار","en":"Um Al Nar"},
          {"ar":"رشيدية","en":"Rashidya"},
          {"ar":"الجرف","en":"Jarf"},
          {"ar":"مصفوط","en":"Masfut"},
          {"ar":"الزهرة","en":"Al Zahra"},
          {"ar":"بستان","en":"Bustan"},
          {"ar":"رملة","en":"Ramlah"},
          {"ar":"حمارية","en":"Hamariya"},
          {"ar":"صباح","en":"Saabah"},
          {"ar":"الكاشفة","en":"Al Khashfah"},
          {"ar":"الجزيرة","en":"Al Jazirah"},
          {"ar":"الجميرة","en":"Jumeirah"},
          {"ar":"الفحيحيل","en":"Fahaheel"},
          {"ar":"صطوة","en":"Satwa"},
          {"ar":"كرامة","en":"Karama"},
          {"ar":"مينا سفوح","en":"Mina Sufooh"},
          {"ar":"السرة","en":"Surra"},
          {"ar":"شندقة","en":"Shandaghah"},
          {"ar":"الكوز","en":"Al Qouz"},
          {"ar":"بور دبي","en":"Bur Dubai"},
          {"ar":"ديرة","en":"Deira"},
          {"ar":"جبل علي","en":"Jebal Ali"},
          {"ar":"ام القوين","en":"Um Al Quiwan"},
          {"ar":"الرواية","en":"Al Ruwaiya"},
          {"ar":"القدفة","en":"Qidfa"},
          {"ar":"الهايل","en":"Al Hayl"},
          {"ar":"حتى","en":"Hatta"},
          {"ar":"غنتوت","en":"Ganthoot"},
          {"ar":"روايضه","en":"Rwaydah"},
          {"ar":"الخوض","en":"Al Khodh"},
          {"ar":"حوطة بني تمي","en":"Hawtat Bani Tamim"},
          {"ar":"العامرات","en":"Amerat"},
          {"ar":"خور خوير","en":"Khawr Khuwayr"},
          {"ar":"العذيبة","en":"Azaiba"},
          {"ar":"مجاردا","en":"Majarda"},
          {"ar":"وسيط","en":"Wasit"},
          {"ar":"شرورة","en":"Sharourah"},
          {"ar":"بوشر","en":"Bowsher"},
          {"ar":"عناق","en":"ANAK"},
          {"ar":"الهاير","en":"Al Hayr"},
          {"ar":"ريما","en":"Rima"},
          {"ar":"اوميح","en":"AWAMIAH"},
          {"ar":"خات","en":"Khatt"},
          {"ar":"الشآم","en":"Al Sha'M"},
          {"ar":"اوانات","en":"Awanat"},
          {"ar":"الحاوية","en":"Haweyah"},
          {"ar":"ادهان","en":"Adhan"},
          {"ar":"الجديد","en":"Jadid"},
          {"ar":"الفولية","en":"Al Fulayyah"},
          {"ar":"غلا","en":"Ghala"},
          {"ar":"الحمرانية","en":"Al Hamraniyah"},
          {"ar":"جعفر","en":"Jafar"},
          {"ar":"فرفار","en":"Furfar"},
          {"ar":"الجاشي","en":"Al-Jsh"},
          {"ar":"شام","en":"Sham"},
          {"ar":"فلج الملا","en":"Falaj Al Mulla"},
          {"ar":"قاسمية","en":"Qasimiya"},
          {"ar":"رمقية","en":"Ramaqiya"},
          {"ar":"نخيلات","en":"Nakheelat"},
          {"ar":"نصارية","en":"Nasariya"},
          {"ar":"المبراز","en":"Mubaraz"},
          {"ar":"المنيفه","en":"Mnefah"},
          {"ar":"موافجة","en":"Muwafja"},
          {"ar":"موليجة","en":"Molejah"},
          {"ar":"نابايا","en":"Nabiya"},
          {"ar":"نانايه","en":"Nanyah"},
          {"ar":"سلطان قابوس","en":"Madinat Sultan Qaboos"},
          {"ar":"نوريه","en":"Noweirieh"},
          {"ar":"نباعة","en":"Nabbah"},
          {"ar":"الموالح","en":"Mawaleh"},
          {"ar":"وجام","en":"Ojam"},
          {"ar":"مجارة","en":"Majjarah"},
          {"ar":"منصورة","en":"Mansoora"},
          {"ar":"قرة","en":"QARAH"},
          {"ar":"ليا","en":"Layyah"},
          {"ar":"ميسلون","en":"Maisaloon"},
          {"ar":"الصفوة","en":"Safwa"},
          {"ar":"خنور","en":"Khannur"},
          {"ar":"قافية","en":"Ghafia"},
          {"ar":"قبيبة","en":"Ghubaiba"},
          {"ar":"داسمان","en":"Dasman"},
          {"ar":"دهيد","en":"Dhaid"},
          {"ar":"بادية","en":"Badiyah"},
          {"ar":"بطينة","en":"Buteena"},
          {"ar":"التاوون","en":"Al Tawoon"},
          {"ar":"وادي الكبير","en":"Wadi Kabir"},
          {"ar":"العوابي مسقط","en":"Al Awabi - Muscat"},
          {"ar":"العوابي بركا","en":"Al Awabi - Barka"},
          {"ar":"شهانية","en":"Shahaniya"},
          {"ar":"السايلية","en":"Al Sailiya"},
          {"ar":"الحمرا","en":"Al Hamra"},
          {"ar":"الغزير","en":"Al Ghazir"},
          {"ar":"ام صلالة علي","en":"Umm Salal 'Ali"},
          {"ar":"العقابية","en":"Al Qa`abiyah"},
          {"ar":"القابيل","en":"Al Kabil"},
          {"ar":"الخور","en":"Al Khor"},
          {"ar":"كامل و وافي ","en":"Al Kamil Wal Wafi"},
          {"ar":"الخليفات","en":"Al Khalifat"},
          {"ar":"المضيبي","en":"Al Mudhaibi"},
          {"ar":"بهلا","en":"Bahla"},
          {"ar":"الجمالية","en":"Al Jumaliyah"},
          {"ar":"الادباه","en":"Al Adhbah"},
          {"ar":"بدبد","en":"Bidbid"},
          {"ar":"بخا","en":"Bukha"},
          {"ar":"جريان البطنة","en":"jarian albatinah"},
          {"ar":"ضنك","en":"Dhank"},
          {"ar":"دبا","en":"Diba"},
          {"ar":"الغانم","en":"Ghanim"},
          {"ar":"ابو دالوف","en":"Abu dhalouf"},
          {"ar":"هيماء","en":"Haima"},
          {"ar":"إبرا","en":"Ibra"},
          {"ar":"ابو ثيلان","en":"Abu Thaylan"},
          {"ar":"المرقاب","en":"Mirqab"},
          {"ar":"جعلان بني بو","en":"Jaalan Bani Bu Ali"},
          {"ar":"جعلان ني بو ","en":"Jaalan ni Bu Hassan"},
          {"ar":"البيدا الغرب","en":"Al Bida alGharbiyah"},
          {"ar":"ابو سديرة","en":"Abu Sudayrah"},
          {"ar":"ليوا","en":"Liwa"},
          {"ar":"مدحاء","en":"Madha"},
          {"ar":"مناح","en":"Manah"},
          {"ar":"النخل","en":"Nakhl"},
          {"ar":"صحم","en":"Saham"},
          {"ar":"شناص","en":"Shinas"},
          {"ar":"صور ","en":"Sur"},
          {"ar":"السويق","en":"Suwaiq"},
          {"ar":"وادي بني خال","en":"Wadi Bani Khalid"},
          {"ar":"قطنا","en":"Qatana"},
          {"ar":"الصمد شان","en":"Samad Al Shan"},
          {"ar":"الجديدة","en":"Al Jadida"},
          {"ar":"شارع السعادة","en":"Al Saada"},
          {"ar":"السادة","en":"Sadah"},
          {"ar":"المزيونة","en":"Mazyona"},
          {"ar":"ميناء سلمان","en":"Mina Salman"},
          {"ar":"رأس الرمان","en":"Ras Ruman"},
          {"ar":"السلمانية","en":"Salmaniya"},
          {"ar":"السيف","en":"Seef"},
          {"ar":"ام الحسام","en":"Um Alhassam"},
          {"ar":"العالي","en":"Aali"},
          {"ar":"مدينة عيسى","en":"Isa Town"},
          {"ar":"جردبا","en":"Jordab"},
          {"ar":"منسفه","en":"Nasfah"},
          {"ar":"سلماباد","en":"Salmabad"},
          {"ar":"سند","en":"Sanad"},
          {"ar":"توبلي","en":"Tubli"},
          {"ar":"مدينة زايد","en":"Zayed Town"},
          {"ar":"أمواج","en":"Amwaj"},
          {"ar":"اراد","en":"Arad"},
          {"ar":"البسيتين","en":"Busaiteen"},
          {"ar":"دير","en":"Dair"},
          {"ar":"الحد","en":"Hidd"},
          {"ar":"قلالي","en":"Qalali"},
          {"ar":"سماهيج","en":"Samaheej"},
          {"ar":"جزيرة تالا","en":"Tala Island"},
          {"ar":"ابو بيهام","en":"Abu Beham"},
          {"ar":"أبو صيبع","en":"Abu Saiba"},
          {"ar":"بني جمرة","en":"Bani Jamra"},
          {"ar":"بربر","en":"Barbar"},
          {"ar":"بو قوة","en":"Buquwa"},
          {"ar":"بوري","en":"Buri"},
          {"ar":"دار كليب","en":"Dar Kulaib"},
          {"ar":"الدراز","en":"Diraz"},
          {"ar":"دمستان","en":"Dumistan"},
          {"ar":"حجر","en":"Hajar"},
          {"ar":"مدينة حمد","en":"Hamad Town"},
          {"ar":"الهملة","en":"Hamala"},
          {"ar":"حلة عبدالصال","en":"Hillat Abdulsaleh"},
          {"ar":"الجنبية","en":"Janabiya"},
          {"ar":"جنوسان","en":"Jannusan"},
          {"ar":"جبلة حبشي","en":"Jiblat Habshi"},
          {"ar":"جد الحاج","en":"Jid Alhaj"},
          {"ar":"جدحفص","en":"Jidhafs"},
          {"ar":"كرانة","en":"Karrana"},
          {"ar":"كرزكان","en":"Karzakan"},
          {"ar":"خميس","en":"Khamis"},
          {"ar":"المرخ","en":"Markh"},
          {"ar":"مقابة","en":"Muqaba"},
          {"ar":"المصلى","en":"Musalla"},
          {"ar":"شمال السهلة","en":"North Sehla"},
          {"ar":"القدم","en":"Qadam"},
          {"ar":"القرية","en":"Qurayya"},
          {"ar":"سار","en":"Saar"},
          {"ar":"سداد","en":"Sadad"},
          {"ar":"الصخير","en":"Sakheir"},
          {"ar":"شهركان","en":"Shahrakan"},
          {"ar":"شاخورة","en":"Shakhura"},
          {"ar":"جنوب السهلة","en":"South Sehla"},
          {"ar":"طاشان","en":"Tashan"},
          {"ar":"ام الصبان","en":"Umm Alsabban (Mohammadiya)"},
          {"ar":"الزلاق","en":"Zallaq"},
          {"ar":"الرفاع الشرق","en":"East Riffa"},
          {"ar":"الرفاع الغرب","en":"West Riffa"},
          {"ar":"العدلية","en":"Adliya"},
          {"ar":"الجفير","en":"Juffair"},
          {"ar":"ظفار","en":"Zofar"},
          {"ar":"حسان ديبا","en":"Hassan Dibba"},
          {"ar":"الجزيرة ","en":"Al Jazirah Al Hamra"},
          {"ar":"اليرموك","en":"Yarmook"},
          {"ar":"القيوين ","en":"Um Al Quiwan"},
          {"ar":"بيشة ","en":"Bisha"},
          {"ar":"ابو عريش ","en":"Abu Areish"},
          {"ar":"افلاج","en":"Aflaj"},
          {"ar":"عهد مصرحة","en":"AHAD MASARHA"},
          {"ar":"عهد رفيدة","en":"Ahad Rufaidah"},
          {"ar":"الدالمية","en":"Al Dalemya"},
          {"ar":"المدا","en":"Al Mada"},
          {"ar":"الارطاوية","en":"Artawiah"},
          {"ar":"عسفان","en":"Asfan"},
          {"ar":"عين فهيد","en":"Ayn Fuhayd"},
          {"ar":"البحرة","en":"Bahara"},
          {"ar":"القنفذة","en":"Qunfudah"},
          {"ar":"السلع","en":"Sila"},
          {"ar":"الطريف","en":"Turaif"},
          {"ar":"مينا سلمان","en":"Mina Salman"},
          {"ar":"راس رمان ","en":"Ras Ruman"},
          {"ar":"السيف ","en":"Seef"},
          {"ar":"العالي ","en":"Aali"},
          {"ar":"جزيرة تالا ","en":"Tala Island"},
          {"ar":"جنوب سهلة","en":"South Sehla"},
          {"ar":"شمال سهلة","en":"North Sehla"},
          {"ar":"مبارك الكبير","en":"Mubarak Al kabeer"},
          {"ar":"الصليبيه","en":"Sulaybiyah"},
          {"ar":"البيان","en":"Bayan"},
          {"ar":"احمدي","en":"Ahmadi"},
          {"ar":"الخودة","en":"alkhodh"},
          {"ar":"البدايعة","en":"albidayah"},
          {"ar":"جعلان بن حسن","en":"jaalan bani bu hassan"},
          {"ar":"الخابورة","en":"khabourah"},
          {"ar":"سور","en":"sur"},
          {"ar":"وادي المعويل","en":"wadi al maawil"},
          {"ar":"الهتمي ","en":"Al hitmi"},
          {"ar":"ام سعيد ","en":"umm said"},
          {"ar":"ام صلال علي ","en":"umm salal ali"},
          {"ar":"القبيعية","en":"alqabiyah"},
          {"ar":"الرويضة","en":"Rwaydah"},
          {"ar":"الحريق","en":"Hareeq"},
          {"ar":"المجاردة","en":"Majarda"},
          {"ar":"الشرورة","en":"Sharourah"},
          {"ar":"العوامية","en":"Awamiah"},
          {"ar":"الحوية","en":"Haweyah"},
          {"ar":"الحرض","en":"Harad"},
          {"ar":"الجفر","en":"Jafar"},
          {"ar":"الجيش","en":"Al-Jsh"},
          {"ar":"الخضرية","en":"Khodaria"},
          {"ar":"الذيد","en":"Al Dhayd"},
          {"ar":"المنيفة","en":"Mnefah"},
          {"ar":"جميره","en":"Jumeirah"},
          {"ar":"السطوة","en":"Satwa"},
          {"ar":"القوز","en":"Al Qouz"},
          {"ar":"المولجيه","en":"Molejah"},
          {"ar":"أم القيوان","en":"Um Al Quiwan"},
          {"ar":"النبيه","en":"Nabiya"},
          {"ar":"الروية","en":"Al Ruwaiya"},
          {"ar":"النانيه","en":"Nanyah"},
          {"ar":"ابو ظبي ","en":"Abu Dhabi"},
          {"ar":"النعيرية","en":"Noweirieh"},
          {"ar":"العجام","en":"Ojam"},
          {"ar":"العثمانية","en":"Othmanyah"},
          {"ar":"القره","en":"Qarah"},
          {"ar":"راس التنورة","en":"Ras Tanura"},
          {"ar":"الرحيمة","en":"Rahima"},
          {"ar":"السفانية","en":"Safanyah"},
          {"ar":"التنجيب","en":"Tanjeeb"},
          {"ar":"العضيليه","en":"Udhaliyah"},
          {"ar":"العيون","en":"Uyun"},
          {"ar":"جعرانه","en":"Ja'Araneh"},
          {"ar":"المستورة","en":"Mastura"},
          {"ar":"الشعيبة ","en":"Shoaiba"},
          {"ar":"بحره","en":"Bahara"},
          {"ar":"الزحبان","en":"Zahban"},
          {"ar":"المجود","en":"Bahrat Al Moujoud"},
          {"ar":"النويره","en":"Nwariah"},
          {"ar":"الشميسي","en":"Shumeisi"},
          {"ar":"البرك","en":"Birk"},
          {"ar":"القهمة","en":"Qahmah"},
          {"ar":" ابطن","en":" IBTIN"},
          {"ar":" اعبلين","en":" I'BILLIN"},
          {"ar":" اكسال","en":" IKSAL"},
          {"ar":" البقيعة","en":" PEQI'IN (BUQEI'A)"},
          {"ar":" الجش","en":" JISH(GUSH HALAV)"},
          {"ar":" الخضيرة","en":" HADERA"},
          {"ar":" الرملة","en":" RAMLA"},
          {"ar":" الريحانية.","en":" REIHANIYYE"},
          {"ar":" الرينة","en":" REINE"},
          {"ar":" الزرازير","en":"ZARZIR"},
          {"ar":" الشيخ دنون","en":" SHEIKH DANNUN"},
          {"ar":" الطيبة.","en":"TAYIBE"},
          {"ar":" الغجر","en":" GHAJAR"},
          {"ar":" الفريديس","en":" FUREIDIS"},
          {"ar":" الكمانه","en":" KAMANE"},
          {"ar":" اللد","en":" LOD"},
          {"ar":" المزرعة","en":" MAZRA'A"},
          {"ar":" المغار","en":"MAGGAL"},
          {"ar":" المقيبلة","en":" MUQEIBLE"},
          {"ar":" الناصرة","en":" NAZARETH"},
          {"ar":" الناعورة","en":" NA'URA"},
          {"ar":" الهيب","en":" RUMAT HEIB"},
          {"ar":" ام الريحان","en":"REHAN"},
          {"ar":" ام الفحم","en":" UMM AL-FAHM"},
          {"ar":" ام القطف","en":" UMM AL-QUTUF"},
          {"ar":" بيتح تكفا","en":" PETAH TIQWA"},
          {"ar":" ترشيحا","en":" MA'ALOT-TARSHIHA"},
          {"ar":" تل السبع.","en":" TEL SHEVA"},
          {"ar":" جديدة المكر","en":" גדיידה-מכר"},
          {"ar":" جسر الزرقاء","en":" JISR AZ-ZARQA"},
          {"ar":" جفعات زئيف","en":" GIV'AT ZE'EV"},
          {"ar":" جلجوليا","en":" JALJULYE"},
          {"ar":" جولس.","en":" JULIS"},
          {"ar":" حرفيش","en":"HURFEISH"},
          {"ar":" حريش","en":" HURFEISH"},
          {"ar":" حورة","en":" HURA"},
          {"ar":" حولون","en":" HOLON"},
          {"ar":" حيفا","en":"Haifa"},
          {"ar":" دالية الكرمل","en":" DALIYAT AL-KARMEL-ISIFYA"},
          {"ar":" دير الاسد","en":" Dier Al Asad"},
          {"ar":" دير حنا..","en":" דייר חנא"},
          {"ar":" ديمونا","en":" DIMONA"},
          {"ar":" راس علي","en":" RAS ALI"},
          {"ar":" رعنانا","en":" RA'ANNANA"},
          {"ar":" رمات جان","en":" RAMAT GAN"},
          {"ar":" رهط","en":" RAHAT"},
          {"ar":" ريشون ليتسيون","en":"RISHPON"},
          {"ar":" زيمر","en":"ZEMER"},
          {"ar":" ساجور","en":" SAJUR"},
          {"ar":" سخنين","en":" SAKHNIN"},
          {"ar":" شفا عمرو","en":" SHEFAR'AM"},
          {"ar":" شقيب السلام","en":" SEGEV-SHALOM"},
          {"ar":" شوهام","en":"SHOHAM"},
          {"ar":" صفد","en":"ZEFAT"},
          {"ar":" صفوريه","en":" ZIPPORI"},
          {"ar":" صندلة","en":" SANDALA"},
          {"ar":" طبريا","en":"TIBERIAS"},
          {"ar":" طرعان","en":" TUR'AN"},
          {"ar":" طمرة","en":"TAMRA"},
          {"ar":" طوبا الزنغارية","en":" TUBA-ZANGARIYYE"},
          {"ar":" طيرة المثلث","en":" TIRE"},
          {"ar":" عرب الشبلي","en":" SHIBLI-UMM AL-GHANAM"},
          {"ar":" عيلبون.,","en":" EILABUN"},
          {"ar":" عيلوط","en":" ILUT"},
          {"ar":" عين حوض","en":" EN HOD"},
          {"ar":" عين رافا","en":" EIN RAFA"},
          {"ar":" عين ماهل","en":" EIN MAHEL"},
          {"ar":" عين نقوبا.","en":" EIN NAQQUBA"},
          {"ar":" فسوطة","en":" FASSUTA"},
          {"ar":" قصير","en":" TEL QAZIR"},
          {"ar":" قلنسوه","en":" QALANSAWE"},
          {"ar":" كابول","en":" KABUL"},
          {"ar":" كسرى","en":" KISRA-SUMEI"},
          {"ar":" كسيفة","en":" KUSEIFE"},
          {"ar":" كعيبة","en":" KA'ABIYYE-TABBASH-HAJAJRE"},
          {"ar":" كفار سابا","en":" KEFAR SAVA"},
          {"ar":" كفر برا","en":" KAFAR BARA"},
          {"ar":" كفر قاسم","en":" KAFAR QASEM"},
          {"ar":" كفر قرع","en":" KAFAR QARA"},
          {"ar":" كفر كما","en":" KAFAR KAMA"},
          {"ar":" كفر كنا","en":" KAFAR KANNA"},
          {"ar":" كفر مصر","en":" KAFAR MISR"},
          {"ar":" كفر مندا","en":" KAFAR MANDA"},
          {"ar":" كفر ياسيف","en":" KAFAR YASIF"},
          {"ar":" كوكب ابو الهيجاء","en":" KAOKAB ABU AL-HIJA"},
          {"ar":" مجدل شمس","en":" MAJDAL SHAMS"},
          {"ar":" مصمص","en":" MA'ALE IRON"},
          {"ar":" منشيه زبدة","en":" MANSHIYYET ZABDA"},
          {"ar":" موديعين","en":" MODI'IN ILLIT"},
          {"ar":" ميسر","en":" MEISER"},
          {"ar":" نتانيا","en":" NETANYA"},
          {"ar":" نحف.","en":" NAHEF"},
          {"ar":" نهاريا","en":" NAHARIYYA"},
          {"ar":" نوف هجليل","en":"NOV"},
          {"ar":" نين","en":" NEIN"},
          {"ar":" وادي الحمام","en":" HAMAM"},
          {"ar":" وادي سلامة","en":" SALLAMA"},
          {"ar":" يافا","en":" TEL AVIV - YAFO"},
          {"ar":" يركا","en":"YIRKA"},
          {"ar":"مجد الكروم","en":" מגד אל-כרום"},
          {"ar":" الجبعة","en":" Al-Jab'a"},
          {"ar":" الحجيلة","en":" Al-Hajeila"},
          {"ar":" الحدايدة","en":" Al-Hadayda"},
          {"ar":" الحلقوم","en":" Halqoom"},
          {"ar":" الخضر","en":" Al-Khader"},
          {"ar":" الدهيشة","en":"Al duhaisheh camp"},
          {"ar":" الدوحة","en":" Doha"},
          {"ar":" الشواورة","en":" Shawawra"},
          {"ar":" العبيدية","en":" Obeidiya"},
          {"ar":" العساكرة","en":" Alasakra"},
          {"ar":" القبو","en":" Al-Qabo"},
          {"ar":" المعصرة","en":" Al-Ma'sara"},
          {"ar":" المنشية","en":" Mansheya"},
          {"ar":" أم سلمونة","en":" Umm Salmuna"},
          {"ar":" بتير","en":" Battir"},
          {"ar":" بيت تعمر","en":" Beit Tamor"},
          {"ar":" بيت جالا","en":" Biet Jala"},
          {"ar":" بيت ساحور","en":" Biet Sahour"},
          {"ar":" بيت فجار","en":" Beit Fajjar"},
          {"ar":" بيت لحم","en":" Bethlehem"},
          {"ar":" جبة الذيب","en":" Jobet Al-Theib"},
          {"ar":" جهاثم","en":" Jahathem"},
          {"ar":" جورة الشمعة","en":" Joura Shamaa"},
          {"ar":" حوسان","en":" Hossan"},
          {"ar":" خربة الدير","en":" Khirbet al-Deir"},
          {"ar":" خربة النخلة","en":" Khirbet al-Nakhla"},
          {"ar":" خربة تقوع","en":" Khirbat Tekoa"},
          {"ar":" دار صلاح","en":" Dar Salah"},
          {"ar":" رخمة","en":" Rakhma"},
          {"ar":" ظهرة الندى","en":" Tharet Al-Nada"},
          {"ar":" عرب الرشايدة","en":" Arab Rashaida"},
          {"ar":" مراح معلا","en":" Marah Ma'alla"},
          {"ar":" نحالين","en":" Nahalin"},
          {"ar":" وادي العرايس","en":" Wadi Al - Arayes"},
          {"ar":" وادي النيص","en":" Wadi Al-Neis"},
          {"ar":" وادي رحال","en":" Wadi Rahal"},
          {"ar":" وادي فوكين","en":" Wadi Fookin"},
          {"ar":"مراح رباح","en":" Marah Rabah"},
          {"ar":"الولجة","en":" Walaja"},
          {"ar":" اذنا","en":" Ethna"},
          {"ar":" التواني","en":" Al-Tawani"},
          {"ar":" الجبلية","en":" Al-Jabalyeh"},
          {"ar":" الخليل","en":" Hebron"},
          {"ar":" الدوايمة","en":" Al-Dawaymeh"},
          {"ar":" الرماضين","en":" Ramadin"},
          {"ar":" السموع","en":" samou'"},
          {"ar":" الشيوخ","en":" Al-Shyookh"},
          {"ar":" الصرة","en":" Al-Sorra"},
          {"ar":" الظاهرية","en":" Al-Dahriyeh"},
          {"ar":" العديسة","en":"Adaysa"},
          {"ar":" الكوم","en":" Koom"},
          {"ar":" امريش","en":" Emrich"},
          {"ar":" أم برج","en":" Um Borj"},
          {"ar":" بركوسيا","en":" Barkoosya"},
          {"ar":" بيت الروش الفوقا","en":" Beit Al-roush Al-Fooqa"},
          {"ar":" بيت امر","en":" Biet Ommar"},
          {"ar":" بيت أولا","en":" Beit Aola"},
          {"ar":" بيت جبرين","en":" Beit Jibrin"},
          {"ar":" بيت عمرة","en":" Beit Umra"},
          {"ar":" بيت عوا","en":" Beit Awwa"},
          {"ar":" بيت مرسم","en":" Beit Marsam"},
          {"ar":" بيت نتيف","en":" Bet Netive"},
          {"ar":" ترقوميا","en":" Tarqumia"},
          {"ar":" تفوح","en":" Taffouh"},
          {"ar":" تل الصافي","en":" Tell Al-Safi"},
          {"ar":" جالا","en":" Jala"},
          {"ar":" جبعة","en":" Jaba'a"},
          {"ar":" حدب الفوار","en":" Hadab Al-Fowwar"},
          {"ar":" حلحول","en":" Halhoul"},
          {"ar":" خربة عتير","en":" Khirbet Atir"},
          {"ar":" خرسا","en":" Kharsa"},
          {"ar":" دورا","en":" doura"},
          {"ar":" دير الدبان","en":" Deir al-Daban"},
          {"ar":" دير العسل الفوقا","en":" Deir Al-Asal Al-Fawqa"},
          {"ar":" دير رازح","en":" Deir Razih"},
          {"ar":" دير نخاس","en":" Deir Nekhas"},
          {"ar":" رابود","en":" Raboud"},
          {"ar":" رافات","en":" Rafat"},
          {"ar":" زكريا","en":"Zakaria"},
          {"ar":" زيف","en":"Zeif"},
          {"ar":" سعير","en":" Saeer"},
          {"ar":" سنجر","en":" Sinjer"},
          {"ar":" طرامة","en":" Trama"},
          {"ar":" عجور","en":" Ajour"},
          {"ar":" عناب الكبير","en":" Annab Al-Kabeer"},
          {"ar":" كدنة","en":" Kadna"},
          {"ar":" كرمة","en":" Karma"},
          {"ar":" كويزبة","en":" Quizba"},
          {"ar":" وادي الشاجنة","en":" Wadi Al-Shajna"},
          {"ar":" يطا","en":"Yatta"},
          {"ar":" البارد الهاشمية","en":" Al-Bared Al-Hashemiyeh"},
          {"ar":" الخلجان","en":" Al-Khaljan"},
          {"ar":" الرامة","en":" Rama"},
          {"ar":" الزبابدة","en":" Al-Zababdeh"},
          {"ar":" السيلة الحارثية","en":" Seleh Al-Harethiyeh"},
          {"ar":" العطارة","en":" Al-Atara"},
          {"ar":" العقبة","en":" Aqaba"},
          {"ar":" الفندقومية","en":" Al-Fondoqawmiyeh"},
          {"ar":" الكفير","en":" Kfir"},
          {"ar":" اللجون","en":" Lajoun"},
          {"ar":" المزار","en":" Al-Mazar"},
          {"ar":" المغير","en":" Al-Mughayer"},
          {"ar":" اليامون","en":" Yamon"},
          {"ar":" ألمانية","en":" German"},
          {"ar":" أم التوت","en":" Um Al-Toot"},
          {"ar":" أم الريحان","en":" Um Al-Rayhan"},
          {"ar":" أم دار","en":" Um Dar"},
          {"ar":" برطعة","en":" Barta'a"},
          {"ar":" برقين","en":" Burqin"},
          {"ar":" بيت قاد","en":" Beit Qad"},
          {"ar":" بير الباشا","en":" Bir El Basha"},
          {"ar":" تعنك","en":" Tannak"},
          {"ar":" تلفيت","en":" Talfeet"},
          {"ar":" جبع","en":" Jaba'"},
          {"ar":" جبل حريش","en":" Jabal Hreesh"},
          {"ar":" جديدة","en":" Jdeedeh"},
          {"ar":" جربا","en":" Jarba"},
          {"ar":" جلبون","en":" Jalaboon"},
          {"ar":" جلقموس","en":" Jalqamos"},
          {"ar":" جلمة","en":" Jalama"},
          {"ar":" جنزور","en":" Janzur"},
          {"ar":" جنين","en":" Jenin"},
          {"ar":" خربة الجوفة","en":" Khirbet al-Jufa"},
          {"ar":" خربة المطلة","en":" Khirbet al-Mutla"},
          {"ar":" خربة طورة الغربية","en":" Khirbet Tourah al-Gharbia"},
          {"ar":" خربة عبد الله اليونس","en":" Khirbat Abdullah al-Yunis"},
          {"ar":" خربة نزلة زيد","en":" Khirbat Nazlat Zaid"},
          {"ar":" دير أبو ضعيف","en":" Deir Abu Da'eef"},
          {"ar":" دير غزالة","en":" Deir Ghazala"},
          {"ar":" رابا","en":" Raba"},
          {"ar":" رمانة","en":" Rammana"},
          {"ar":" زبدة","en":" Zabda"},
          {"ar":" زبوبا","en":" Zaboba"},
          {"ar":" سيلة الظهر","en":" Selet Al daher"},
          {"ar":" صانور","en":" Sanoor"},
          {"ar":" صير","en":" Sir"},
          {"ar":" طورة الشرقية","en":" East Tura"},
          {"ar":" طيبة","en":" Tayba"},
          {"ar":" عابا","en":" Aappa"},
          {"ar":" عانين","en":" Aneen"},
          {"ar":" عجة","en":" Ajja"},
          {"ar":" عرابة","en":" Araba"},
          {"ar":" عرانة","en":" Arana"},
          {"ar":" عربونة","en":" Arbona"},
          {"ar":" عرقة","en":" Araqa"},
          {"ar":" عطارة","en":" Atara"},
          {"ar":" عنزة","en":" Anza"},
          {"ar":" عين المنسي","en":" Ain Al-Mansi"},
          {"ar":" فحمة","en":" Fahma"},
          {"ar":" فراسين","en":" Fraseen"},
          {"ar":" فقوعة","en":" Faqqoua'a"},
          {"ar":" قباطية","en":" Qabatiya"},
          {"ar":" قصر المشاكي","en":" Mashaki Palace"},
          {"ar":" كفر دان","en":" Kafr Dan"},
          {"ar":" كفر راعي","en":" Kafr Ra'i"},
          {"ar":" كفر قود","en":" Kafr Goud"},
          {"ar":" كفير","en":"Kefir"},
          {"ar":" كفيرت","en":" Kufert"},
          {"ar":" مثلث الشهداء","en":" The Shohada' Triangle"},
          {"ar":" مخيم جنين","en":" jenin camp"},
          {"ar":" مسلية","en":" Musaleya"},
          {"ar":" منشية العطارى","en":" Mansheyet Al-Attari"},
          {"ar":" نزلة الشيخ زيد","en":" Nazlet Al-Sheikh Zeid"},
          {"ar":" هاشمية","en":" Hashimiyah"},
          {"ar":" يعبد","en":" yabad"},
          {"ar":"زرعين","en":" Zare'een"},
          {"ar":" اريحا","en":" Jericho"},
          {"ar":" العوجا","en":" Auja"},
          {"ar":" النبي موسى","en":"Al-Nabi Mousa"},
          {"ar":" النويعمة","en":" Al-Nuwaimeh"},
          {"ar":" ديوك","en":" Deywook"},
          {"ar":"الجفتلك","en":" Jiftlik"},
          {"ar":" الساوية","en":" Al-Sawya"},
          {"ar":" العقربانية","en":"Al-Aqrabanieh"},
          {"ar":" اللبن الشرقية","en":" Eastern Lubban"},
          {"ar":" الناقورة الجنوبية","en":" South Naqoura"},
          {"ar":" اوصرين","en":" Osreen"},
          {"ar":" إجنسنيا","en":" Egnesnia"},
          {"ar":" برقة","en":" Burqa"},
          {"ar":" بزاريا","en":" Bazaria"},
          {"ar":" بلاطة البلد","en":" Ballatah"},
          {"ar":" بورين","en":" Burin"},
          {"ar":" بيت امرين","en":" Beit Emreen"},
          {"ar":" بيت ايبا","en":" Beit Iba"},
          {"ar":" بيت دجن","en":" Beit Dajan"},
          {"ar":" بيت فوريك","en":" Beit Furik"},
          {"ar":" بيت وزن","en":" Beit Wazan"},
          {"ar":" بيتا","en":" Beta"},
          {"ar":" تل","en":" Tel"},
          {"ar":" تلفيت.","en":" Telfeet"},
          {"ar":" جالود","en":" Jalud"},
          {"ar":" جبل باي يزيد","en":" Mount Bai Yazeed"},
          {"ar":" جماعين","en":" Jamma'een"},
          {"ar":" جوريش","en":" Joreish"},
          {"ar":" حجة","en":" Hajjah"},
          {"ar":" حوارة","en":" Hawara"},
          {"ar":" دوما","en":" Duma"},
          {"ar":" دير الحطب","en":" Deir al-Hatab"},
          {"ar":" دير شرف","en":" Deir Sharaf"},
          {"ar":" رامين","en":" Rameen"},
          {"ar":" رفيديا","en":" Rafedia"},
          {"ar":" روجيب","en":" Roujeb"},
          {"ar":" زيتا جماعين","en":" Zeta Jamaa'een"},
          {"ar":" سالم","en":" Salem"},
          {"ar":" سبسطية","en":" Sabastia"},
          {"ar":" سبسطية الجديدة","en":" New Sebastia"},
          {"ar":" سنيرية","en":" Sniriya"},
          {"ar":" صرة","en":" Surah"},
          {"ar":" عزموط","en":" Azmout"},
          {"ar":" عسكر البلد","en":" Askar"},
          {"ar":" عصيرة الشمالية","en":" Northern Asira"},
          {"ar":" عصيرة القبلية","en":" Asira Al-Qibliya"},
          {"ar":" عقربا","en":" Aqrabah"},
          {"ar":" عورتا","en":" Awarta"},
          {"ar":" عوريف","en":" Auref"},
          {"ar":" قصرة","en":" Kusrah"},
          {"ar":" كفر قليل","en":" Kafr Qallil"},
          {"ar":" مادما","en":" Madma"},
          {"ar":" مجدل بني فاضل","en":" Majdal Bani Fadel"},
          {"ar":" نابلس","en":" Nablus"},
          {"ar":" نص اجبيل","en":" Nus Gbail"},
          {"ar":" يتما","en":" Yetma"},
          {"ar":"زواتا","en":" Zuata"},
          {"ar":" الرماضين الجنوبي","en":" Southern Ramadin"},
          {"ar":" الرماضين الشمالي","en":" Northern Ramadin"},
          {"ar":" الفندق","en":" Al-Fondok"},
          {"ar":" المدور","en":" Al-mudwar"},
          {"ar":" النبي إلياس","en":" Al-Nabi Elias"},
          {"ar":" إماتين","en":" Emateen"},
          {"ar":" باقة الحطب","en":" Baket AL-Hatab"},
          {"ar":" بيت أمين","en":" Biet Amen"},
          {"ar":" جيت","en":" Giet"},
          {"ar":" جيوس","en":" Geoss"},
          {"ar":" حبلة","en":" Habbleh"},
          {"ar":" راس طيرة","en":" Ras Tira"},
          {"ar":" راس عطية","en":" Ras Atiya"},
          {"ar":" عزبة الأشقر","en":" Ezbet Al Ashqar"},
          {"ar":" عزبة الطبيب","en":" Ezbet Al-Tabeeb"},
          {"ar":" عزبة جلعود","en":" Ezbet Ghaloud"},
          {"ar":" عزبة سلمان","en":" Ezbet Salman"},
          {"ar":" عزون","en":" Azzun"},
          {"ar":" عزون عتمة","en":" Azzun Atma"},
          {"ar":" عسلة","en":" Asslah"},
          {"ar":" فرعتا","en":" Fara'tah"},
          {"ar":" فلامية","en":" Flamyah"},
          {"ar":" قلقيلية","en":" Qalqilia"},
          {"ar":" كفر ثلث","en":" Kafr Thulth"},
          {"ar":" كفر قدوم","en":" Kafr Kaddoum"},
          {"ar":" كفر لاقف","en":"Kafr Lakhef"},
          {"ar":" مغارة الضبعة","en":" Magharet AL-Dabaa"},
          {"ar":"واد الرشا","en":" Wad Al Rasha"},
          {"ar":" الارسال","en":" Al- Irsal"},
          {"ar":" الجانية","en":" Al-Janyeh"},
          {"ar":" الطيبة","en":" Al-Tayba"},
          {"ar":" الطيرة- رام الله","en":" Al-Tira"},
          {"ar":" اللبن الغربي","en":" Western Lebban"},
          {"ar":" الماصيون","en":" Masyoun"},
          {"ar":" المزرعة الشرقية","en":" Eastern Al-Mazra'a"},
          {"ar":" المزرعة القبلية","en":" Southern Al-Mazra'a"},
          {"ar":" ام الشرايط","en":" Om Alsharayet"},
          {"ar":" أبو شخيدم","en":" Abu Shkheidam"},
          {"ar":" أبو قش","en":" Abu Qash"},
          {"ar":" أبوشخيدم","en":" Abu Shkheidam"},
          {"ar":" ألماصيون","en":" AL Masyoun"},
          {"ar":" بدرس","en":" Bodros"},
          {"ar":" برقة","en":" Borqa"},
          {"ar":" بلعين","en":" Bil'in"},
          {"ar":" بيت إكسا","en":" Beit Exa"},
          {"ar":" بيت إللو","en":" Beit Ello"},
          {"ar":" بيت ريما","en":" Beit Rima"},
          {"ar":" بيت سيرا","en":" Beit Sira"},
          {"ar":" بيت عور التحتا","en":" Beit Awar al-Tahta"},
          {"ar":" بيت عور الفوقا","en":" Beit Awr al-Fawqa"},
          {"ar":" بيت لقيا","en":" Beit Leqia"},
          {"ar":" بيتونيا","en":" Betunia"},
          {"ar":" بيتين","en":" Betin"},
          {"ar":" بيرزيت","en":" Birzeit"},
          {"ar":" ترمسعيا","en":" Tirmseya"},
          {"ar":" جفنا","en":" Jafna"},
          {"ar":" جلجيليا","en":" Jaljulia"},
          {"ar":" جمالا","en":" Jammala"},
          {"ar":" جيبيا","en":" Jibia"},
          {"ar":" خربة أبو فلاح","en":" Khirbet Abu Falah"},
          {"ar":" خربتا المصباح","en":" Kharbatha Al-Musbah"},
          {"ar":" دورا القرع","en":" Dora Al-Qare'"},
          {"ar":" دير السودان","en":" Deir Al-Soudan"},
          {"ar":" دير إبزيع","en":" Deir Ebzee'"},
          {"ar":" دير أبو مشعل","en":" Deir Abu Misha'al"},
          {"ar":" دير جرير","en":" Dier Jarir"},
          {"ar":" دير دبوان","en":" Deir Dibwan"},
          {"ar":" دير عمار","en":" Deir Ammar"},
          {"ar":" دير غسانة","en":" Deir Ghassana"},
          {"ar":" دير قديس","en":" Deir Qaddees"},
          {"ar":" دير نضام","en":" Deir Nizam"},
          {"ar":" رام الله والبيرة","en":"Ramallah and Al-Bireh"},
          {"ar":" رأس كركر","en":" Ras Karkar"},
          {"ar":" رمون","en":" Rammon"},
          {"ar":" رنتيس","en":" Rantis"},
          {"ar":" سردا","en":" Surda"},
          {"ar":" سلواد","en":" Selwad"},
          {"ar":" سنجل","en":" Senjel"},
          {"ar":" شبتين","en":" Shebteen"},
          {"ar":" شقبا","en":" Shuqba"},
          {"ar":" صفا","en":" Saffa"},
          {"ar":" عابود","en":" Aboud"},
          {"ar":" عارورة","en":" Arora"},
          {"ar":" عبوين","en":" Abween"},
          {"ar":" عجول","en":" Ajoul"},
          {"ar":" عطارة","en":" Atara"},
          {"ar":" عين سينيا","en":" Ain Sinaia"},
          {"ar":" عين عريك","en":" Ain Arik"},
          {"ar":" عين قينيا","en":" Ain Qinya"},
          {"ar":" عين يبرود","en":" Ain Yabroud"},
          {"ar":" قبية","en":" Qebya"},
          {"ar":" قراوة بني زيد","en":" Karawat Bani Zaid"},
          {"ar":" قطنا","en":" Qatana"},
          {"ar":" كفر عين","en":" Kafr Ain"},
          {"ar":" كفر مالك","en":" Kafr Malik"},
          {"ar":" كفر نعمة","en":" kofor Neama"},
          {"ar":" كوبر","en":" Koober"},
          {"ar":" مزارع النوباني","en":" Mazare' Alnobani"},
          {"ar":" نعلين","en":" Ni'lin"},
          {"ar":"يبرود","en":" Yabroud"},
          {"ar":" اسكاكا","en":" Iskaka"},
          {"ar":" بديا","en":"Bedia"},
          {"ar":" بروقين","en":" Burqin"},
          {"ar":" حارس","en":" Hares"},
          {"ar":" خربة قيس","en":" Khirbet Qais"},
          {"ar":" دير استيا","en":" Deir Estya"},
          {"ar":" رافات","en":" Rafat"},
          {"ar":" سرطة","en":" Sarta"},
          {"ar":" سلفيت","en":" Salfit"},
          {"ar":" قراوة بني حسان","en":" Qarawat Bani Hassan"},
          {"ar":" قيرة","en":" Qeera"},
          {"ar":" كفر الديك","en":" Kafr El Deek"},
          {"ar":" كفل حارس","en":" Kfel guard"},
          {"ar":" مردة","en":" Marda"},
          {"ar":" مسحة","en":" Masha"},
          {"ar":"ياسوف","en":" Yasuf"},
          {"ar":" النصارية","en":"Nasiriyah"},
          {"ar":" تياسير","en":" Tayseer"},
          {"ar":" حمرة","en":" Hamra"},
          {"ar":" سيريس","en":" Serees"},
          {"ar":" صير","en":" Sir"},
          {"ar":" طلوزة","en":" Talouza"},
          {"ar":" طمون","en":" Tammoun"},
          {"ar":" طوباس","en":" Tubas"},
          {"ar":" عقابا","en":" Aqqaba"},
          {"ar":" عقبة","en":" Aqaba"},
          {"ar":" عين البيضاء","en":" Ain al-Bayda"},
          {"ar":" كردلا","en":" Kordala"},
          {"ar":" مخيم الفارعة","en":" Al-Faraah Camp"},
          {"ar":" واد الفارعة","en":" Wad Al Fara'a"},
          {"ar":"واد حمد","en":" Wad Hamad"},
          {"ar":" ارتاح","en":" Ertah"},
          {"ar":" النزلة الشرقية","en":" Eastern Nazleh"},
          {"ar":" إكتابا","en":" Ektaba"},
          {"ar":" أم خالد","en":" Umm Khaled"},
          {"ar":" باقة الشرقية","en":"Eastern Baqa"},
          {"ar":" بلعا","en":" Bala'a"},
          {"ar":" بيت ليد","en":" Beit Leed"},
          {"ar":" خربة بيت ليد","en":" Khirbet Beit Lid"},
          {"ar":" دير الغصون","en":" Deir al-Ghosun"},
          {"ar":" ذنابة","en":" Thennaba"},
          {"ar":" سفارين","en":" Saffareen"},
          {"ar":" شعراوية","en":" Sha'rawyeh"},
          {"ar":" شوفة","en":" Shoufa"},
          {"ar":" شويكة","en":" Shweikeh"},
          {"ar":" صيدا","en":" Seida"},
          {"ar":" طولكرم","en":" Tulkarem"},
          {"ar":" عتيل","en":" Attil"},
          {"ar":" عكابا","en":" Akkaba"},
          {"ar":" عنبتا","en":" Anabta"},
          {"ar":" فرعون","en":" Faroun"},
          {"ar":" قفين","en":" Qaffin"},
          {"ar":" كفر اللبد","en":" Kafr El Labd"},
          {"ar":" كفر جمال","en":" Kafr Jamal"},
          {"ar":" كفر رمان","en":" Kafr Rumman"},
          {"ar":" كفر زيباد","en":" Kafr Zebad"},
          {"ar":" كفر صور","en":" Kafr Sour"},
          {"ar":" كفر عبوش","en":" Kafr Abush"},
          {"ar":" نزلة أبو نار","en":" Nazlat Abu Nar"},
          {"ar":" نزلة عيسى","en":" Nazlat Issa"},
          {"ar":" وادي الشعير","en":" Wade Al-She'eer"},
          {"ar":"زيتا","en":" Zeta"},
          {"ar":" ابو ديس.","en":" Abu Dies."},
          {"ar":" البدو.","en":" Bidou."},
          {"ar":" الجديرة.","en":" Al Judairah"},
          {"ar":" الجيب.","en":" Al Jeeb"},
          {"ar":" الرام.","en":" Al Ram"},
          {"ar":" الزعيم","en":" Al- Zaiem"},
          {"ar":" السواحرة الشرقية.","en":"Eastern Sawahreh"},
          {"ar":" العيزرية.","en":" Bethany / Al Ezzariyeh"},
          {"ar":" القبيبة.","en":" Qbiebeh"},
          {"ar":" بيت دقو.","en":" Biet Doqou"},
          {"ar":" بيت سوريك.","en":" Biet Souriek"},
          {"ar":" بيت عنان.","en":" Biet Enan"},
          {"ar":" بير نبالا","en":" Bier Nabala"},
          {"ar":" جبع القدس","en":" Jaba' Quds"},
          {"ar":" حزما.","en":" Hizma."},
          {"ar":" رافات.","en":" Rafat."},
          {"ar":" سوار القدس- ضفة","en":" jerusalem- west bank"},
          {"ar":" عناتا.","en":" Anata."},
          {"ar":" كفر عقب.","en":" Kofor Aqab."},
          {"ar":" مخيم قلنديا","en":" Qalandia camp"},
          {"ar":"مخيم شعفاط.","en":" Shu'afat camp."},
          {"ar":" البلدة القديمة","en":" Old City"},
          {"ar":" التلة الفرنسية","en":" French Hill"},
          {"ar":" الثوري/ ابو طور","en":" A-Thuri/ Abu Tor"},
          {"ar":" الحي الإسلامي","en":" Islamic Quarter"},
          {"ar":" السواحرة الغربية.","en":" Western Sawahreh"},
          {"ar":" الشياح","en":" Al Shayyah"},
          {"ar":" الشيخ جراح","en":" Sheikh Jarrah"},
          {"ar":" الشيخ سعد","en":" Sheikh Saad"},
          {"ar":" الصوانة","en":" Al Sowaneh"},
          {"ar":" الطور","en":" Al-Toor"},
          {"ar":" العيسوية","en":" Issawiya"},
          {"ar":" القدس","en":" Jerusalem"},
          {"ar":" أم طوبا","en":" Um Tuba"},
          {"ar":" بيت حنينا","en":"Beit Hanina"},
          {"ar":" بيت صفافا","en":" Beit Safafa"},
          {"ar":" جبل المكبر","en":" Jabal Al-mokabber"},
          {"ar":" حارة النصارى","en":" Haret Al-Nasara"},
          {"ar":" راس العامود","en":" Ras Al Amoud"},
          {"ar":" سلوان","en":" Silwan"},
          {"ar":" شرفات","en":" Sharfat"},
          {"ar":" شعفاط","en":" Shu'afat"},
          {"ar":" صور باهر","en":" Sour Baher"},
          {"ar":" عطروت","en":" Atarout"},
          {"ar":" وادي الجوز","en":" Wadi Al Jouz"},
          {"ar":" وادي قدوم","en":" Wadi Qadoum"},
          {"ar":"أربيل","en":"Erbil"},
          {"ar":"الأنبار","en":"Anbar"},
          {"ar":"بابل","en":"Babil"},
          {"ar":"بغداد","en":"Baghdad"},
          {"ar":"كرخ","en":"Karkh"},
          {"ar":"رصافة","en":"Rusafa"},
          {"ar":"البصرة","en":"Basra"},
          {"ar":"دهوك","en":"Duhok"},
          {"ar":"القادسية","en":"Qadsiya"},
          {"ar":"ديالى","en":"Diala"},
          {"ar":"ذيقار","en":"Thiqar"},
          {"ar":"السليمانية","en":"Sulaymaniyah"},
          {"ar":"صلاح الدين","en":"Salah Aldeen"},
          {"ar":"كركوك","en":"Kirkuk"},
          {"ar":"كربلاء","en":"Karbala"},
          {"ar":"المثنى","en":"Muthana"},
          {"ar":"ميسان","en":"Maisan"},
          {"ar":"النجف","en":"Najaf"},
          {"ar":"نينوى","en":"Ninawa"},
          {"ar":"واسط","en":"Waset"},
          {"ar":"غزة","en":"Gaza"},
          {"ar":"باقة الغربية","en":"baqa algharbia"},
          {"ar":"عرابة البطوف","en":"Arrabah Al-Battouf"},
          {"ar":"سمره","en":"Samra"},
          {"ar":"إجدابيا","en":"EJDABIA"},
          {"ar":"الجفرة","en":"Al Joufra"},
          {"ar":"الخمس","en":"AL KOMAS"},
          {"ar":"أوجلة","en":"OGLA"},
          {"ar":"البيضاء","en":"AL BEIDA"},
          {"ar":"البريقة","en":"BREGA"},
          {"ar":"بنغازي","en":"Bengahzi"},
          {"ar":"بير الأشهب","en":"Bengahzi"},
          {"ar":"بني وليد","en":"Beni Walid"},
          {"ar":"شحات","en":"Shahat"},
          {"ar":"درنة","en":"Derna"},
          {"ar":"الأبيار","en":"Al Abyar"},
          {"ar":"العزيزيه","en":"Al Azizieh"},
          {"ar":"القطرون","en":"Gatron"},
          {"ar":"الكفرة","en":"Koufra"},
          {"ar":"المرج","en":"Marj"},
          {"ar":"غات","en":"Ghat"},
          {"ar":"غدامس","en":"Ghademes"},
          {"ar":"قمينس","en":"Ghemenis"},
          {"ar":"غريان","en":"gherian"},
          {"ar":"هون","en":"hun"},
          {"ar":"الجغبوب","en":"al jaboob"},
          {"ar":"جالو","en":"Jalo"},
          {"ar":"جنزور","en":"Tripoli"},
          {"ar":"كاباو","en":"Kabaw"},
          {"ar":"مرادة (مردة)","en":"Marada"},
          {"ar":"مصراتة","en":"Musrata"},
          {"ar":"مرزق","en":"Murzaq"},
          {"ar":"نالوت","en":"Naloot"},
          {"ar":"صبراتة","en":"Sebrata"},
          {"ar":"سبها","en":"Sabha"},
          {"ar":"سلوق","en":"Soloq"},
          {"ar":"سرت","en":"Sirt"},
          {"ar":"ترهونة","en":"Tarhuna"},
          {"ar":"تازربو","en":"Tazerbo"},
          {"ar":"طبرق","en":"Tobruq"},
          {"ar":"توكرة","en":"Tokra"},
          {"ar":"تراغن","en":"Tragen"},
          {"ar":"أبوسليم","en":"Tripoli"},
          {"ar":"طرابلس","en":"tripoli"},
          {"ar":"اوباري","en":"obari"},
          {"ar":"جردس العبيد","en":"gerda"},
          {"ar":"الزاوية","en":"zawia"},
          {"ar":"زلة","en":"zla"},
          {"ar":"زلطن","en":"reqdalen"},
          {"ar":"زليتن","en":"zlitin"},
          {"ar":"زوارة","en":"zwara"},
          {"ar":"اجخرة (جخرد)","en":"Bengahzi"},
          {"ar":"الأبرق","en":"Bengahzi"},
          {"ar":"الأصابعة","en":"gherian"},
          {"ar":"الجميل","en":"al jamel"},
          {"ar":"الحرابة","en":"Naloot"},
          {"ar":"الحوامد","en":"Naloot"},
          {"ar":"الداوون","en":"Tarhuna"},
          {"ar":"الرجبان","en":"al rejban"},
          {"ar":"الرحيبات","en":"al rehebat"},
          {"ar":"الرياينة","en":"alriyayna"},
          {"ar":"الزنتان","en":"alzintan"},
          {"ar":"الزهراء","en":"alzahra"},
          {"ar":"الساحل","en":"zwara"},
          {"ar":"السبيعة (اسبيعة)","en":"tripoli"},
          {"ar":"السواني","en":"al swani"},
          {"ar":"الشاطئ الشرقي","en":"Bengahzi"},
          {"ar":"الشاطئ الغربي","en":"zwara"},
          {"ar":"الشرقية","en":"Bengahzi"},
          {"ar":"الشقيقة","en":"gherian"},
          {"ar":"العجيلات","en":"al agelat"},
          {"ar":"الغريفة","en":"alghurayfah"},
          {"ar":"القبة","en":"al quba"},
          {"ar":"القرضة","en":"sabha"},
          {"ar":"القره بوللي","en":"al garaboli"},
          {"ar":"القلعة","en":"gherian"},
          {"ar":"القيقب","en":"Bengahzi"},
          {"ar":"الماية","en":"maia"},
          {"ar":"أم الرزم","en":"Sabha"},
          {"ar":"امساعد","en":"msaeed"},
          {"ar":"باطن الجبل","en":"badr"},
          {"ar":"بنت بيه","en":"sabha"},
          {"ar":"تاجوراء","en":"tajoura"},
          {"ar":"تاورغاء","en":"taworgha"},
          {"ar":"جادو","en":"jadoo"},
          {"ar":"حي الأندلس","en":"tripoli"},
          {"ar":"خليج السدرة","en":"BREGA"},
          {"ar":"رقدالين","en":"reqdalen"},
          {"ar":"زمزم","en":"Bengahzi"},
          {"ar":"ساحل الجبل","en":"jabal"},
          {"ar":"سوق الجمعة","en":"Tripoli"},
          {"ar":"سوق الخميس (سوق الخميس امسيحل)","en":"soq alkhames"},
          {"ar":"سيدي السائح","en":"Tripoli"},
          {"ar":"صرمان","en":"surman"},
          {"ar":"ظاهر الجبل","en":"yefran"},
          {"ar":"غرب الزاوية","en":"zawia"},
          {"ar":"قصر الأخيار","en":"qasar alkhaiar"},
          {"ar":"قصر بن غشير","en":"Q. benghasher"},
          {"ar":"ككلة","en":"kikla"},
          {"ar":"مسلاتة","en":"meselata"},
          {"ar":"نسمة","en":"nesma"},
          {"ar":"وادي الربيع","en":"Tripoli"},
          {"ar":"وادي عتبة (تساوة وادي عتبة)","en":"Sabha"},
          {"ar":"وازن","en":"wazen"},
          {"ar":"يفرن","en":"yefran"},
          {"ar":"مزدة","en":"mezda"},
          {"ar":"سوسه","en":"derna"},
          {"ar":"راس لانوف","en":"Ras al anof"},
          {"ar":"مرسى البريقة","en":"Marsa"},
          {"ar":"الفقهة","en":"El Foqha"},
          {"ar":"براك","en":"sabha"},
          {"ar":"الزويتينة","en":"bengahzi"},
          {"ar":"ودان","en":"Wdan"},
          {"ar":"سوكنة","en":"Sokna"},
          {"ar":"درج","en":"dirj"},
          {"ar":"لدري","en":"edrie"},
          {"ar":"العربان","en":"al orban"},
          {"ar":"سيناون","en":"Sinawin"},
          {"ar":"الدار البيضاء ","en":"CASABLANCA"},
          {"ar":"الرباط","en":"RABAT"},
          {"ar":"تمارة","en":"TEMARA"},
          {"ar":"عين عتيق ","en":"AIN ATIQ"},
          {"ar":"الصخيرات","en":"SKHIRAT"},
          {"ar":"سيدي يحيى زعير ","en":"SIDI YAHYA ZAER"},
          {"ar":"سلا","en":"SALE"},
          {"ar":"سيدي بوقنادل","en":"SIDI BOUKNADEL"},
          {"ar":"سيدي طيبي ","en":"SIDI TAIBI"},
          {"ar":"القنيطرة","en":"KENITRA"},
          {"ar":"المحمدية","en":"MOHAMMEDIA"},
          {"ar":"عين حرودة","en":"AIN HARROUDA"},
          {"ar":"تيط مليل ","en":"TIT MELLIL"},
          {"ar":"دار بوعزة","en":"DAR BOUAZZA"},
          {"ar":"الدروة","en":"DEROUA"},
          {"ar":"النواصر","en":"NOUACEUR"},
          {"ar":"مديونة","en":"MEDIOUNA"},
          {"ar":"السوالم","en":"SOUALEM"},
          {"ar":"طنجة","en":"TANGER"},
          {"ar":"تطوان","en":"TETOUAN"},
          {"ar":"مارتيل","en":"MARTIL"},
          {"ar":"المضيق","en":"M'DIQ"},
          {"ar":"الفنيدق","en":"FNIDEQ"},
          {"ar":"مراكش","en":"MERRAKESH"},
          {"ar":"تامنصورت","en":"TEMENSOURT"},
          {"ar":"مكناس","en":"MEKNES"},
          {"ar":"الخميسات","en":"KHEMISSET"},
          {"ar":"تيفلت","en":"TIFLET"},
          {"ar":"أزرو","en":"AZROU"},
          {"ar":"إفران","en":"IFRAN"},
          {"ar":"الحاجب","en":"El HAJEB"},
          {"ar":"بوفكران","en":"BOUFAKRANE"},
          {"ar":"فاس","en":"Fes"},
          {"ar":"أكادير","en":"AGADIR"},
          {"ar":"إنزكان","en":"INEZGANE"},
          {"ar":"اين ملول ","en":"AIT MELLOUL"},
          {"ar":"بيوكرى","en":"BIOUGRA"},
          {"ar":"بلفاع","en":"BELFAA"},
          {"ar":"ايت ميلك","en":"AIT MILK"},
          {"ar":"ايت عميرة","en":"AIT AMIRA"},
          {"ar":"تيفنيت","en":"TIFNIT"},
          {"ar":"تاغازوت","en":"TAGHAZOUT"},
          {"ar":"تيزنيت","en":"TIZNIT"},
          {"ar":"تارودانت","en":"TAROUDANT"},
          {"ar":"اولاد تايمة","en":"OULAD TEIMA"},
          {"ar":"الجديدة","en":"EL JADIDA"},
          {"ar":"أزمور","en":"AZEMMOUR"},
          {"ar":"اثنين شتوكة","en":"TNIN CHTOUKA"},
          {"ar":"بير جديد","en":"BIR JDID"},
          {"ar":"سيدي بنور","en":"SIDI BENNOUR"},
          {"ar":"سيدي بوزيد","en":"SIDI BOUZID"},
          {"ar":"سيدي اسماعيل","en":"SIDI SMAIL"},
          {"ar":"خميس زمامرة ","en":"KHEMIS ZEMAMRA"},
          {"ar":"مولاي عبد الله امغار","en":"MOULAY ABDELLAH AMGHAR"},
          {"ar":"الصويرة","en":"ESSAOUIRA"},
          {"ar":"تمنار ","en":"TEMANAR"},
          {"ar":"سيدي كاوكي","en":"SIDI KAOUKI"},
          {"ar":"سميمو","en":"SMIMOU"},
          {"ar":"آسفي","en":"SAFI"},
          {"ar":"الناظور","en":"NADOR"},
          {"ar":"الدريوش","en":"DRIOUCH"},
          {"ar":"زايو","en":"ZAIO"},
          {"ar":"بني انصار ","en":"BENI ANSAR"},
          {"ar":"سلوان ","en":"SELOUANE"},
          {"ar":"الزغنغن","en":"ZEGHANGHANE"},
          {"ar":"العروي","en":"AL AROUI"},
          {"ar":"جعدار ","en":"JAADAR"},
          {"ar":"وجدة","en":"OUJDA"},
          {"ar":"الحسيمة","en":"AL HOCEIMA"},
          {"ar":"السعيدية","en":"SAIDIA"},
          {"ar":"بركان","en":"BERKANE"},
          {"ar":"أحفير","en":"AHFIR"},
          {"ar":"كلميم","en":"GUELMIM"},
          {"ar":"طانطان","en":"TANTAN"},
          {"ar":"العيون","en":"LAAYOUNE"},
          {"ar":"العيون المرسى","en":"LAAYOUNE PORT"},
          {"ar":"الداخلة","en":"DAKHLA"},
          {"ar":"السمارة","en":"ES SEMARA"},
          {"ar":"بوجدور","en":"BOUJDOUR"},
          {"ar":"سلا الجديدة","en":"SALA AL JADIDA"},
          {"ar":"بني ملال ","en":"BENI MELLAL"},
          {"ar":"الفقيه بن صالح","en":"FKIH BEN SALAH"},
          {"ar":"أزيلال","en":"AZILAL"},
          {"ar":"بين الويدان ","en":"BIN EL-OUIDANE"},
          {"ar":"خنيفرة","en":"KHENIFRA"},
          {"ar":"قصبة تادلة","en":"KASBA TADLA"},
          {"ar":"زاوية الشيخ ","en":"ZAOUIAT CHEIKH"},
          {"ar":"أفورار","en":"AFOURAR"},
          {"ar":"واويزغت","en":"OUAOUIZEGHT"},
          {"ar":"القصيبة","en":"EL KSIBA"},
          {"ar":"تاكزيرت","en":"TAGZIRT"},
          {"ar":"برشيد","en":"Berrechid"},
          {"ar":"طماريس","en":"TAMARIS"},
          {"ar":"بوسكورة","en":"BOUSKOURA"},
          {"ar":"السطات","en":"SETTAT"},
          {"ar":"جرادة","en":"Jerada"},
          {"ar":"العرائش","en":"Larache"},
          {"ar":"القصر الكبير","en":"Ksar el-Kebir"},
          {"ar":"جرسيف","en":"Guercif"},
          {"ar":"تاوريرت","en":"Taourirt"},
          {"ar":"سيدي بيبي ","en":"sidi bibi"},
          {"ar":"سيدي إفني","en":"Sidi Ifni"},
          {"ar":"القصر الصغير","en":"Ksar es Seghir"},
          {"ar":"بوعرفة","en":"Bouarfa"},
          {"ar":"العرجات","en":"El Aarjate"},
          {"ar":"سيدي علال البحراوي","en":"Sidi Allal el Bahraoui"},
          {"ar":"تامصلوحت","en":"Tamesluht"},
          {"ar":"عين تاوجطات ","en":"Ain Taoujdate"},
          {"ar":"تامسنا","en":"Tamesna"},
          {"ar":"أولاد النمة","en":"Awlad-An-Nama"},
          {"ar":"البرادية","en":"Bradia"},
          {"ar":"إغرم العلام ","en":"Ighrem Laâlam"},
          {"ar":"بني عياط","en":"Beni Ayat"},
          {"ar":"أولاد عياد","en":"Oulad Ayad"},
          {"ar":"تاكزرت","en":"Tagzert"},
          {"ar":"أولاد مبارك","en":"Oulad Embarek"},
          {"ar":"أولاد زمام ","en":"Oulad Zmam"},
          {"ar":"سيدي جابر ","en":"Sidi Jaber"},
          {"ar":"أولاد عياش ","en":"Oulad Yaich"},
          {"ar":"فم العنصر ","en":"Foum El Anceur"},
          {"ar":"تانوغة","en":"Tanougha"},
          {"ar":"الرحمة","en":"RAHMA"},
          {"ar":"بن سليمان ","en":"Benslimane"},
          {"ar":"بوزنيقة","en":"Bouznika"},
          {"ar":"عين عودة","en":"Ain El Aouda"},
          {"ar":"دراركة","en":"Drarga"},
          {"ar":"المهاية ","en":"M'haya"},
          {"ar":"البهاليل ","en":"Bhalil"},
          {"ar":"ماسة","en":"Massa"},
          {"ar":"سيدي قاسم ","en":"Sidi Kacem"},
          {"ar":"سيدي سليمان ","en":"Sidi Slimane"},
          {"ar":"سوق الأربعاء","en":"Souk El Arbaa"},
          {"ar":"مشرع بلقصيري","en":"Mechra Bel Ksiri"},
          {"ar":"جرف الملحة ","en":"Jorf El Melha"},
          {"ar":"حد كورت","en":"Had Kourt"},
          {"ar":"خريبكة","en":"Khouribga"},
          {"ar":"قصبة تادلة","en":"Kasbah TADLA"},
          {"ar":"بن احمد","en":"Benahmed"},
          {"ar":"واد زم","en":"Oued Zem"},
          {"ar":"أبو الجعد","en":"Boujad"},
          {"ar":"سيدي موسى ( مراكش ) ","en":"Sidi Moussa (Marrakesh)"},
          {"ar":"اوريكة","en":"Ourika"},
          {"ar":"الحوز ","en":"Al Haouz"},
          {"ar":"أغمات ","en":"Aghmat"},
          {"ar":"تاحناوت","en":"Tahnaout"},
          {"ar":"أصيلة","en":"Asilah"},
          {"ar":"تادارت ","en":"Taddart"},
          {"ar":"ايت اورير","en":"Ait Ourir"},
          {"ar":"زمران الشرقية","en":"Zemrane Charqia"},
          {"ar":"أنزا العليا ","en":"Haut Anza"},
          {"ar":"تازة","en":"Taza"},
          {"ar":"تاهلة ","en":"TAHLA"},
          {"ar":"واد إمليل","en":"OUED AMLIL"},
          {"ar":"العيون سيدي ملوك ","en":"LAAYOUN (sidi mellouk)"},
          {"ar":"العرجات","en":"ElArjat"},
          {"ar":"القليعة العين ","en":"leqliaa alain"},
          {"ar":"أورير","en":"Aourir"},
          {"ar":"بن طيب","en":"Ben Tayab"},
          {"ar":"شفشاون","en":"Chefchaouen"},
          {"ar":"التمسية ","en":"temsia"},
          {"ar":"تيكيوين","en":"Tikiouine"},
          {"ar":"تماعيت إزدر","en":"Tamait Izder"},
          {"ar":"وزان ","en":"wazan"},
          {"ar":"شيشاوة","en":"Chichaoua"},
          {"ar":"امنتانوت","en":"Imintanoute"},
          {"ar":"تفتاشت","en":"Tafetachte"},
          {"ar":"خميس تاكاط","en":"Khemis Takate"},
          {"ar":"بريكوات","en":"Birkouate"},
          {"ar":"مجي","en":"Mejji"},
          {"ar":"تالمست","en":"Talmest"},
          {"ar":"تمنار ","en":"Tamanar"},
          {"ar":"أوناغة ","en":"Ounagha"},
          {"ar":"الحنشان ","en":"El Hanchane"},
          {"ar":"البويهات","en":"Labouihate"},
          {"ar":"أقرمود","en":"Aquermoud"},
          {"ar":"حد درعة","en":"Had Draa"},
          {"ar":"دوار تيصغارين ","en":"Douar Tisgharin"},
          {"ar":"ديابات ","en":"Diabat"},
          {"ar":"زاوية بوزرقطون","en":"Zaouiet Bouzarktoune"},
          {"ar":"ميظار","en":"midar"},
          {"ar":"الشماعية ","en":"Chemaia"},
          {"ar":"ورزازات ","en":"Ouarzazate"},
          {"ar":"ايت بن حدو","en":"Aït Benhaddou"},
          {"ar":"أكويم ","en":"Agouim"},
          {"ar":"أكدز","en":"Agdz"},
          {"ar":"تازناخت","en":"Tazenakht"},
          {"ar":"سكورة","en":"Skoura"},
          {"ar":"قلعة مكونة","en":"Kalaat M'Gouna"},
          {"ar":"تينغير","en":"Tinghir"},
          {"ar":"زاكورة","en":"Zagora"},
          {"ar":"ميدلت","en":"Midelt"},
          {"ar":"الريش","en":"Er-Rich"},
          {"ar":"ميسور","en":"Missour"},
          {"ar":"بومية","en":"Boumia"},
          {"ar":"زايدة","en":"Zaida"},
          {"ar":"الراشيدية","en":"Errachidia"},
          {"ar":"أوفوس","en":"Aoufous"},
          {"ar":"أرفود","en":"Erfoud"},
          {"ar":"الريصاني","en":"Rissani"},
          {"ar":"كلميمة","en":"Goulmima"},
          {"ar":"تنجداد","en":"Tinejdad"}
      ]
      let c = city.filter(x=>x.ar == o)
      if(c.length && c[0]){
        return c[0].en
      } else {
        return country
      }
    },
    async genCartId(lead, amount, currency){
      let data = {
        data:{
          'entityId': '8ac9a4c973519d7701735247fe2e0cb5',
          'amount': amount.toFixed(2),
          'currency': 'USD',
          'paymentType': 'DB',
          'merchantTransactionId':randomString(12, '#Aa'),
          'customer.email':`${lead.phone_number_1}@ashyaat.com`,
          // 'customer.givenName':`${lead.name}`,
          // 'customer.surname':`${lead.name}`,
          'customer.merchantCustomerId':lead.key,
          'customParameters[SHOPPER_customerId]':lead.key,
          'billing.street1':`${this.replaceCity(lead.city, lead.payment_cc)}`, 
          'billing.city':`${lead.city}`,
          'billing.state':`${lead.city}`,
          'billing.country':`${lead.payment_cc}`,
          'billing.postcode':`00000`,
        }
      }
      console.log(data);
      let a = await axios.post(`${apiBase}/generateHyperPayID`, data, headers).then(x=>x.data.data)
      console.log(a)
      this.cart_token = await this.encrypt(a.id)
      console.log(this.cart_token)
      this.buildForm(lead, a.id)
    },
    async buildForm(lead, id){
      let s = document.createElement('script')
      s.src = `https://oppwa.com/v1/paymentWidgets.js?checkoutId=${id}`
      let b = document.createElement('script')
      b.innerHTML = `
        var wpwlOptions = {
          locale: "${this.language}",
          style: "plain",
          paymentTarget:"_top",
          forceCardHolderEqualsBillingName: true,
          showCVVHint: true,
          brandDetection: true,
          onReady: function(){ 
            $(".wpwl-group-cardNumber").after($(".wpwl-group-brand").detach());
            $(".wpwl-group-cvv").after( $(".wpwl-group-cardHolder").detach());
            var visa = $(".wpwl-brand:first").clone().removeAttr("class").attr("class", "wpwl-brand-card wpwl-brand-custom wpwl-brand-VISA")
            var master = $(visa).clone().removeClass("wpwl-brand-VISA").addClass("wpwl-brand-MASTER");
            $(".wpwl-brand:first").after( $(master)).after( $(visa));
          },
          onChangeBrand: function(e){
            $(".wpwl-brand-custom").css("opacity", "0.3");
            $(".wpwl-brand-" + e).css("opacity", "1"); 
          }
        }
      `
      document.head.appendChild(b)
      document.head.appendChild(s)
      this.loading = false
      // console.clear()
    },
    async getProducts() {
      (async x=>{
        for (let i = 0; i < this.lead.order.length; i++) {
          const item = this.lead.order[i];
          let p = await db.ref('products').orderByChild('sku').equalTo(item.sku).once('value').then(x=>x.val())
          if(p){
            let c = Object.values(p).filter(x=>x.name_ar)[0]
            this.lead.order[i].name_ar = c.name_ar ? c.name_ar : null
            this.lead.order[i].name_en = c.name_en ? c.name_en : null
            this.lead.order[i].img = c.img ? c.img : null
          }
        }
        this.products = true
      })()
    }
  },
  async created(){
    let p = this.$route.params
    if(p && p.token) {
      this.loading = true
      this.token = p.token
      this.key = await this.decrypt(p.token)
      this.GetLead(this.key)
    } else {
    }
    setTimeout(x=>{
      console.log('reload')
      window.location.reload()
    },  10 * 60 * 1000)
  }
}
</script>

<style>
.arFont { 
  font-family: 'Cairo', sans-serif !important;
  direction:rtl;
}
.arFontOnly { 
  font-family: 'Cairo', sans-serif !important;
}

.cnpBillingCheckoutWrapper {position:relative;}
.cnpBillingCheckoutHeader {width:100%;border-bottom: 1px solid #c0c0c0;margin-bottom:10px;}
.cnpBillingCheckoutLeft {width:240px;margin-left: 5px;margin-bottom: 10px;border: 1px solid #c0c0c0;display:inline-block;vertical-align: top;padding:10px;}
.cnpBillingCheckoutRight {width:50%;margin-left: 5px;border: 1px solid #c0c0c0;display:inline-block;vertical-align: top;padding:10px;}
.cnpBillingCheckoutOrange {font-size:110%;color: rgb(255, 60, 22);font-weight:bold;}
div.wpwl-wrapper, div.wpwl-label, div.wpwl-sup-wrapper { width: 100% }
div.wpwl-group-expiry, div.wpwl-group-brand { width: 30%; float:left }
div.wpwl-group-cvv { width: 68%; float:left; margin-left:2% }
div.wpwl-group-cardHolder, div.wpwl-sup-wrapper-street1, div.wpwl-group-expiry { clear:both }
div.wpwl-sup-wrapper-street1 { padding-top: 1px }
div.wpwl-wrapper-brand { width: auto }
div.wpwl-sup-wrapper-state, div.wpwl-sup-wrapper-city { width:32%;float:left;margin-right:2% }
div.wpwl-sup-wrapper-postcode { width:32%;float:left }
div.wpwl-sup-wrapper-country { width: 66% }
div.wpwl-wrapper-brand, div.wpwl-label-brand, div.wpwl-brand { display: none;}
div.wpwl-group-cardNumber { width:60%; float:left; font-size: 20px;  }
div.wpwl-group-brand { width:35%; float:left; margin-top:28px }
div.wpwl-brand-card  { width: 65px }
div.wpwl-brand-custom  { margin: 0px 5px; background-image: url("https://oppwa.com/v1/paymentWidgets/img/brand.png") }

</style>